/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader,
  $Writer = $protobuf.Writer,
  $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const vhmptypes = ($root.vhmptypes = (() => {
  /**
   * Namespace vhmptypes.
   * @exports vhmptypes
   * @namespace
   */
  const vhmptypes = {};

  /**
   * Language enum.
   * @name vhmptypes.Language
   * @enum {number}
   * @property {number} JaJp=0 JaJp value
   * @property {number} EnUs=1 EnUs value
   * @property {number} ZhCn=2 ZhCn value
   * @property {number} ViVn=3 ViVn value
   * @property {number} PtPt=4 PtPt value
   * @property {number} MyMM=5 MyMM value
   * @property {number} IdID=6 IdID value
   * @property {number} NeNP=7 NeNP value
   */
  vhmptypes.Language = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = "JaJp")] = 0;
    values[(valuesById[1] = "EnUs")] = 1;
    values[(valuesById[2] = "ZhCn")] = 2;
    values[(valuesById[3] = "ViVn")] = 3;
    values[(valuesById[4] = "PtPt")] = 4;
    values[(valuesById[5] = "MyMM")] = 5;
    values[(valuesById[6] = "IdID")] = 6;
    values[(valuesById[7] = "NeNP")] = 7;
    return values;
  })();

  vhmptypes.I18n = (function () {
    /**
     * Properties of a I18n.
     * @memberof vhmptypes
     * @interface II18n
     * @property {string|null} [jaJp] I18n jaJp
     * @property {string|null} [jaJpKana] I18n jaJpKana
     * @property {string|null} [enUs] I18n enUs
     * @property {string|null} [zhCn] I18n zhCn
     * @property {string|null} [viVn] I18n viVn
     * @property {string|null} [ptPt] I18n ptPt
     * @property {string|null} [myMm] I18n myMm
     * @property {string|null} [idId] I18n idId
     * @property {string|null} [neNp] I18n neNp
     */

    /**
     * Constructs a new I18n.
     * @memberof vhmptypes
     * @classdesc Represents a I18n.
     * @implements II18n
     * @constructor
     * @param {vhmptypes.II18n=} [properties] Properties to set
     */
    function I18n(properties) {
      if (properties)
        for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
          if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
    }

    /**
     * I18n jaJp.
     * @member {string|null|undefined} jaJp
     * @memberof vhmptypes.I18n
     * @instance
     */
    I18n.prototype.jaJp = null;

    /**
     * I18n jaJpKana.
     * @member {string|null|undefined} jaJpKana
     * @memberof vhmptypes.I18n
     * @instance
     */
    I18n.prototype.jaJpKana = null;

    /**
     * I18n enUs.
     * @member {string|null|undefined} enUs
     * @memberof vhmptypes.I18n
     * @instance
     */
    I18n.prototype.enUs = null;

    /**
     * I18n zhCn.
     * @member {string|null|undefined} zhCn
     * @memberof vhmptypes.I18n
     * @instance
     */
    I18n.prototype.zhCn = null;

    /**
     * I18n viVn.
     * @member {string|null|undefined} viVn
     * @memberof vhmptypes.I18n
     * @instance
     */
    I18n.prototype.viVn = null;

    /**
     * I18n ptPt.
     * @member {string|null|undefined} ptPt
     * @memberof vhmptypes.I18n
     * @instance
     */
    I18n.prototype.ptPt = null;

    /**
     * I18n myMm.
     * @member {string|null|undefined} myMm
     * @memberof vhmptypes.I18n
     * @instance
     */
    I18n.prototype.myMm = null;

    /**
     * I18n idId.
     * @member {string|null|undefined} idId
     * @memberof vhmptypes.I18n
     * @instance
     */
    I18n.prototype.idId = null;

    /**
     * I18n neNp.
     * @member {string|null|undefined} neNp
     * @memberof vhmptypes.I18n
     * @instance
     */
    I18n.prototype.neNp = null;

    // OneOf field names bound to virtual getters and setters
    let $oneOfFields;

    /**
     * I18n _jaJp.
     * @member {"jaJp"|undefined} _jaJp
     * @memberof vhmptypes.I18n
     * @instance
     */
    Object.defineProperty(I18n.prototype, "_jaJp", {
      get: $util.oneOfGetter(($oneOfFields = ["jaJp"])),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * I18n _jaJpKana.
     * @member {"jaJpKana"|undefined} _jaJpKana
     * @memberof vhmptypes.I18n
     * @instance
     */
    Object.defineProperty(I18n.prototype, "_jaJpKana", {
      get: $util.oneOfGetter(($oneOfFields = ["jaJpKana"])),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * I18n _enUs.
     * @member {"enUs"|undefined} _enUs
     * @memberof vhmptypes.I18n
     * @instance
     */
    Object.defineProperty(I18n.prototype, "_enUs", {
      get: $util.oneOfGetter(($oneOfFields = ["enUs"])),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * I18n _zhCn.
     * @member {"zhCn"|undefined} _zhCn
     * @memberof vhmptypes.I18n
     * @instance
     */
    Object.defineProperty(I18n.prototype, "_zhCn", {
      get: $util.oneOfGetter(($oneOfFields = ["zhCn"])),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * I18n _viVn.
     * @member {"viVn"|undefined} _viVn
     * @memberof vhmptypes.I18n
     * @instance
     */
    Object.defineProperty(I18n.prototype, "_viVn", {
      get: $util.oneOfGetter(($oneOfFields = ["viVn"])),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * I18n _ptPt.
     * @member {"ptPt"|undefined} _ptPt
     * @memberof vhmptypes.I18n
     * @instance
     */
    Object.defineProperty(I18n.prototype, "_ptPt", {
      get: $util.oneOfGetter(($oneOfFields = ["ptPt"])),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * I18n _myMm.
     * @member {"myMm"|undefined} _myMm
     * @memberof vhmptypes.I18n
     * @instance
     */
    Object.defineProperty(I18n.prototype, "_myMm", {
      get: $util.oneOfGetter(($oneOfFields = ["myMm"])),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * I18n _idId.
     * @member {"idId"|undefined} _idId
     * @memberof vhmptypes.I18n
     * @instance
     */
    Object.defineProperty(I18n.prototype, "_idId", {
      get: $util.oneOfGetter(($oneOfFields = ["idId"])),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * I18n _neNp.
     * @member {"neNp"|undefined} _neNp
     * @memberof vhmptypes.I18n
     * @instance
     */
    Object.defineProperty(I18n.prototype, "_neNp", {
      get: $util.oneOfGetter(($oneOfFields = ["neNp"])),
      set: $util.oneOfSetter($oneOfFields),
    });

    /**
     * Creates a new I18n instance using the specified properties.
     * @function create
     * @memberof vhmptypes.I18n
     * @static
     * @param {vhmptypes.II18n=} [properties] Properties to set
     * @returns {vhmptypes.I18n} I18n instance
     */
    I18n.create = function create(properties) {
      return new I18n(properties);
    };

    /**
     * Encodes the specified I18n message. Does not implicitly {@link vhmptypes.I18n.verify|verify} messages.
     * @function encode
     * @memberof vhmptypes.I18n
     * @static
     * @param {vhmptypes.II18n} message I18n message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    I18n.encode = function encode(message, writer) {
      if (!writer) writer = $Writer.create();
      if (message.jaJp != null && Object.hasOwnProperty.call(message, "jaJp"))
        writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.jaJp);
      if (
        message.jaJpKana != null &&
        Object.hasOwnProperty.call(message, "jaJpKana")
      )
        writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.jaJpKana);
      if (message.enUs != null && Object.hasOwnProperty.call(message, "enUs"))
        writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.enUs);
      if (message.zhCn != null && Object.hasOwnProperty.call(message, "zhCn"))
        writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.zhCn);
      if (message.viVn != null && Object.hasOwnProperty.call(message, "viVn"))
        writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.viVn);
      if (message.ptPt != null && Object.hasOwnProperty.call(message, "ptPt"))
        writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.ptPt);
      if (message.myMm != null && Object.hasOwnProperty.call(message, "myMm"))
        writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.myMm);
      if (message.idId != null && Object.hasOwnProperty.call(message, "idId"))
        writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.idId);
      if (message.neNp != null && Object.hasOwnProperty.call(message, "neNp"))
        writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.neNp);
      return writer;
    };

    /**
     * Decodes a I18n message from the specified reader or buffer.
     * @function decode
     * @memberof vhmptypes.I18n
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {vhmptypes.I18n} I18n
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    I18n.decode = function decode(reader, length) {
      if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
      let end = length === undefined ? reader.len : reader.pos + length,
        message = new $root.vhmptypes.I18n();
      while (reader.pos < end) {
        let tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            message.jaJp = reader.string();
            break;
          }
          case 2: {
            message.jaJpKana = reader.string();
            break;
          }
          case 3: {
            message.enUs = reader.string();
            break;
          }
          case 4: {
            message.zhCn = reader.string();
            break;
          }
          case 5: {
            message.viVn = reader.string();
            break;
          }
          case 6: {
            message.ptPt = reader.string();
            break;
          }
          case 7: {
            message.myMm = reader.string();
            break;
          }
          case 8: {
            message.idId = reader.string();
            break;
          }
          case 9: {
            message.neNp = reader.string();
            break;
          }
          default:
            reader.skipType(tag & 7);
            break;
        }
      }
      return message;
    };

    return I18n;
  })();

  /**
   * ValidationErrorCode enum.
   * @name vhmptypes.ValidationErrorCode
   * @enum {number}
   * @property {number} STRICT_REQUIRED=0 STRICT_REQUIRED value
   * @property {number} STRICT_EMPTY=1 STRICT_EMPTY value
   * @property {number} LT=2 LT value
   * @property {number} LTE=3 LTE value
   * @property {number} GT=4 GT value
   * @property {number} GTE=5 GTE value
   * @property {number} INVALID=10 INVALID value
   * @property {number} INVALID_NUMBER=11 INVALID_NUMBER value
   * @property {number} INVALID_EMAIL=12 INVALID_EMAIL value
   * @property {number} INVALID_PHONE=13 INVALID_PHONE value
   * @property {number} INVALID_ZIPCODE=14 INVALID_ZIPCODE value
   * @property {number} INVALID_KATAKANA=15 INVALID_KATAKANA value
   */
  vhmptypes.ValidationErrorCode = (function () {
    const valuesById = {},
      values = Object.create(valuesById);
    values[(valuesById[0] = "STRICT_REQUIRED")] = 0;
    values[(valuesById[1] = "STRICT_EMPTY")] = 1;
    values[(valuesById[2] = "LT")] = 2;
    values[(valuesById[3] = "LTE")] = 3;
    values[(valuesById[4] = "GT")] = 4;
    values[(valuesById[5] = "GTE")] = 5;
    values[(valuesById[10] = "INVALID")] = 10;
    values[(valuesById[11] = "INVALID_NUMBER")] = 11;
    values[(valuesById[12] = "INVALID_EMAIL")] = 12;
    values[(valuesById[13] = "INVALID_PHONE")] = 13;
    values[(valuesById[14] = "INVALID_ZIPCODE")] = 14;
    values[(valuesById[15] = "INVALID_KATAKANA")] = 15;
    return values;
  })();

  return vhmptypes;
})());

export const vhmformapi = ($root.vhmformapi = (() => {
  /**
   * Namespace vhmformapi.
   * @exports vhmformapi
   * @namespace
   */
  const vhmformapi = {};

  vhmformapi.application = (function () {
    /**
     * Namespace application.
     * @memberof vhmformapi
     * @namespace
     */
    const application = {};

    /**
     * ErrorCode enum.
     * @name vhmformapi.application.ErrorCode
     * @enum {number}
     * @property {number} ERROR_CODE_UNSPECIFIED=0 ERROR_CODE_UNSPECIFIED value
     * @property {number} ERROR_CODE_SUBMIT_LEAD_ID_INVALID=1 ERROR_CODE_SUBMIT_LEAD_ID_INVALID value
     * @property {number} ERROR_CODE_SUBMIT_NEW_APPLICATION_ID_INVALID=2 ERROR_CODE_SUBMIT_NEW_APPLICATION_ID_INVALID value
     * @property {number} ERROR_CODE_SUBMIT_PAYROLL_RECEIVING_ACCOUNT_INVALID=3 ERROR_CODE_SUBMIT_PAYROLL_RECEIVING_ACCOUNT_INVALID value
     * @property {number} ERROR_CODE_SUBMIT_ACCOUNT_TRANSFER_PLAN_ACCOUNT_INVALID=4 ERROR_CODE_SUBMIT_ACCOUNT_TRANSFER_PLAN_ACCOUNT_INVALID value
     * @property {number} ERROR_CODE_SUBMIT_DOCUMENT_5_INCOME_VERIFICATION_INVALID=5 ERROR_CODE_SUBMIT_DOCUMENT_5_INCOME_VERIFICATION_INVALID value
     * @property {number} ERROR_CODE_SUBMIT_PROPERTY_CODE_INVALID=6 ERROR_CODE_SUBMIT_PROPERTY_CODE_INVALID value
     * @property {number} ERROR_CODE_SUBMIT_MOVE_IN_DESIRED_INVALID=7 ERROR_CODE_SUBMIT_MOVE_IN_DESIRED_INVALID value
     * @property {number} ERROR_CODE_SUBMIT_WORKING_STATE_INVALID=8 ERROR_CODE_SUBMIT_WORKING_STATE_INVALID value
     * @property {number} ERROR_CODE_SUBMIT_COUNTRY_ID_INVALID=9 ERROR_CODE_SUBMIT_COUNTRY_ID_INVALID value
     * @property {number} ERROR_CODE_SUBMIT_PERSON_MOBILE_PHONE_INVALID=10 ERROR_CODE_SUBMIT_PERSON_MOBILE_PHONE_INVALID value
     * @property {number} ERROR_CODE_SUBMIT_FIXEDLINE_PHONE_INVALID=11 ERROR_CODE_SUBMIT_FIXEDLINE_PHONE_INVALID value
     * @property {number} ERROR_CODE_SUBMIT_CONTRACT_HOLDER_EMAIL_INVALID=12 ERROR_CODE_SUBMIT_CONTRACT_HOLDER_EMAIL_INVALID value
     * @property {number} ERROR_CODE_SUBMIT_FILE_EXT_INVALID=13 ERROR_CODE_SUBMIT_FILE_EXT_INVALID value
     * @property {number} ERROR_CODE_SUBMIT_FILE_LENGTH_INVALID=14 ERROR_CODE_SUBMIT_FILE_LENGTH_INVALID value
     * @property {number} ERROR_CODE_SUBMIT_SALESFORCE_API_RETURN_INVALID=15 ERROR_CODE_SUBMIT_SALESFORCE_API_RETURN_INVALID value
     * @property {number} ERROR_CODE_SUBMIT_DATE_FORMAT_INVALID=16 ERROR_CODE_SUBMIT_DATE_FORMAT_INVALID value
     * @property {number} ERROR_CODE_GENERATE_PREVIEW_PDF_INVALID=17 ERROR_CODE_GENERATE_PREVIEW_PDF_INVALID value
     */
    application.ErrorCode = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = "ERROR_CODE_UNSPECIFIED")] = 0;
      values[(valuesById[1] = "ERROR_CODE_SUBMIT_LEAD_ID_INVALID")] = 1;
      values[
        (valuesById[2] = "ERROR_CODE_SUBMIT_NEW_APPLICATION_ID_INVALID")
      ] = 2;
      values[
        (valuesById[3] = "ERROR_CODE_SUBMIT_PAYROLL_RECEIVING_ACCOUNT_INVALID")
      ] = 3;
      values[
        (valuesById[4] =
          "ERROR_CODE_SUBMIT_ACCOUNT_TRANSFER_PLAN_ACCOUNT_INVALID")
      ] = 4;
      values[
        (valuesById[5] =
          "ERROR_CODE_SUBMIT_DOCUMENT_5_INCOME_VERIFICATION_INVALID")
      ] = 5;
      values[(valuesById[6] = "ERROR_CODE_SUBMIT_PROPERTY_CODE_INVALID")] = 6;
      values[(valuesById[7] = "ERROR_CODE_SUBMIT_MOVE_IN_DESIRED_INVALID")] = 7;
      values[(valuesById[8] = "ERROR_CODE_SUBMIT_WORKING_STATE_INVALID")] = 8;
      values[(valuesById[9] = "ERROR_CODE_SUBMIT_COUNTRY_ID_INVALID")] = 9;
      values[
        (valuesById[10] = "ERROR_CODE_SUBMIT_PERSON_MOBILE_PHONE_INVALID")
      ] = 10;
      values[
        (valuesById[11] = "ERROR_CODE_SUBMIT_FIXEDLINE_PHONE_INVALID")
      ] = 11;
      values[
        (valuesById[12] = "ERROR_CODE_SUBMIT_CONTRACT_HOLDER_EMAIL_INVALID")
      ] = 12;
      values[(valuesById[13] = "ERROR_CODE_SUBMIT_FILE_EXT_INVALID")] = 13;
      values[(valuesById[14] = "ERROR_CODE_SUBMIT_FILE_LENGTH_INVALID")] = 14;
      values[
        (valuesById[15] = "ERROR_CODE_SUBMIT_SALESFORCE_API_RETURN_INVALID")
      ] = 15;
      values[(valuesById[16] = "ERROR_CODE_SUBMIT_DATE_FORMAT_INVALID")] = 16;
      values[(valuesById[17] = "ERROR_CODE_GENERATE_PREVIEW_PDF_INVALID")] = 17;
      return values;
    })();

    application.SubmitApplicationFormInput = (function () {
      /**
       * Properties of a SubmitApplicationFormInput.
       * @memberof vhmformapi.application
       * @interface ISubmitApplicationFormInput
       * @property {string|null} [leadId] SubmitApplicationFormInput leadId
       * @property {string|null} [language] SubmitApplicationFormInput language
       * @property {string|null} [propertyCode] SubmitApplicationFormInput propertyCode
       * @property {string|null} [bukkakuCode] SubmitApplicationFormInput bukkakuCode
       * @property {string|null} [currentForm] SubmitApplicationFormInput currentForm
       * @property {Array.<string>|null} [formSubmitted] SubmitApplicationFormInput formSubmitted
       * @property {Array.<vhmformapi.application.SubmitApplicationFormInput.ISetupForm>|null} [values] SubmitApplicationFormInput values
       * @property {string|null} [brokerAgentName] SubmitApplicationFormInput brokerAgentName
       * @property {string|null} [brokerAgentNumber] SubmitApplicationFormInput brokerAgentNumber
       * @property {string|null} [brokerAgentEmail] SubmitApplicationFormInput brokerAgentEmail
       * @property {string|null} [brokerShopName] SubmitApplicationFormInput brokerShopName
       * @property {string|null} [brokerShopAddress] SubmitApplicationFormInput brokerShopAddress
       * @property {string|null} [brokerShopNumber] SubmitApplicationFormInput brokerShopNumber
       * @property {string|null} [brokerCustomerName] SubmitApplicationFormInput brokerCustomerName
       * @property {string|null} [brokerCustomerEmail] SubmitApplicationFormInput brokerCustomerEmail
       * @property {string|null} [expiryDate] SubmitApplicationFormInput expiryDate
       * @property {Array.<vhmformapi.application.SubmitApplicationFormInput.IImage>|null} [images] SubmitApplicationFormInput images
       * @property {string|null} [bukkakuId] SubmitApplicationFormInput bukkakuId
       * @property {string|null} [propertyName] SubmitApplicationFormInput propertyName
       * @property {string|null} [buildingName] SubmitApplicationFormInput buildingName
       * @property {string|null} [roomNumber] SubmitApplicationFormInput roomNumber
       */

      /**
       * Constructs a new SubmitApplicationFormInput.
       * @memberof vhmformapi.application
       * @classdesc Represents a SubmitApplicationFormInput.
       * @implements ISubmitApplicationFormInput
       * @constructor
       * @param {vhmformapi.application.ISubmitApplicationFormInput=} [properties] Properties to set
       */
      function SubmitApplicationFormInput(properties) {
        this.formSubmitted = [];
        this.values = [];
        this.images = [];
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * SubmitApplicationFormInput leadId.
       * @member {string} leadId
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.leadId = "";

      /**
       * SubmitApplicationFormInput language.
       * @member {string} language
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.language = "";

      /**
       * SubmitApplicationFormInput propertyCode.
       * @member {string} propertyCode
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.propertyCode = "";

      /**
       * SubmitApplicationFormInput bukkakuCode.
       * @member {string} bukkakuCode
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.bukkakuCode = "";

      /**
       * SubmitApplicationFormInput currentForm.
       * @member {string} currentForm
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.currentForm = "";

      /**
       * SubmitApplicationFormInput formSubmitted.
       * @member {Array.<string>} formSubmitted
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.formSubmitted = $util.emptyArray;

      /**
       * SubmitApplicationFormInput values.
       * @member {Array.<vhmformapi.application.SubmitApplicationFormInput.ISetupForm>} values
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.values = $util.emptyArray;

      /**
       * SubmitApplicationFormInput brokerAgentName.
       * @member {string} brokerAgentName
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.brokerAgentName = "";

      /**
       * SubmitApplicationFormInput brokerAgentNumber.
       * @member {string} brokerAgentNumber
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.brokerAgentNumber = "";

      /**
       * SubmitApplicationFormInput brokerAgentEmail.
       * @member {string} brokerAgentEmail
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.brokerAgentEmail = "";

      /**
       * SubmitApplicationFormInput brokerShopName.
       * @member {string} brokerShopName
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.brokerShopName = "";

      /**
       * SubmitApplicationFormInput brokerShopAddress.
       * @member {string} brokerShopAddress
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.brokerShopAddress = "";

      /**
       * SubmitApplicationFormInput brokerShopNumber.
       * @member {string} brokerShopNumber
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.brokerShopNumber = "";

      /**
       * SubmitApplicationFormInput brokerCustomerName.
       * @member {string} brokerCustomerName
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.brokerCustomerName = "";

      /**
       * SubmitApplicationFormInput brokerCustomerEmail.
       * @member {string} brokerCustomerEmail
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.brokerCustomerEmail = "";

      /**
       * SubmitApplicationFormInput expiryDate.
       * @member {string} expiryDate
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.expiryDate = "";

      /**
       * SubmitApplicationFormInput images.
       * @member {Array.<vhmformapi.application.SubmitApplicationFormInput.IImage>} images
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.images = $util.emptyArray;

      /**
       * SubmitApplicationFormInput bukkakuId.
       * @member {string} bukkakuId
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.bukkakuId = "";

      /**
       * SubmitApplicationFormInput propertyName.
       * @member {string} propertyName
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.propertyName = "";

      /**
       * SubmitApplicationFormInput buildingName.
       * @member {string} buildingName
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.buildingName = "";

      /**
       * SubmitApplicationFormInput roomNumber.
       * @member {string} roomNumber
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @instance
       */
      SubmitApplicationFormInput.prototype.roomNumber = "";

      /**
       * Creates a new SubmitApplicationFormInput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @static
       * @param {vhmformapi.application.ISubmitApplicationFormInput=} [properties] Properties to set
       * @returns {vhmformapi.application.SubmitApplicationFormInput} SubmitApplicationFormInput instance
       */
      SubmitApplicationFormInput.create = function create(properties) {
        return new SubmitApplicationFormInput(properties);
      };

      /**
       * Encodes the specified SubmitApplicationFormInput message. Does not implicitly {@link vhmformapi.application.SubmitApplicationFormInput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @static
       * @param {vhmformapi.application.ISubmitApplicationFormInput} message SubmitApplicationFormInput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      SubmitApplicationFormInput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.leadId != null &&
          Object.hasOwnProperty.call(message, "leadId")
        )
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.leadId);
        if (
          message.language != null &&
          Object.hasOwnProperty.call(message, "language")
        )
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.language);
        if (
          message.propertyCode != null &&
          Object.hasOwnProperty.call(message, "propertyCode")
        )
          writer
            .uint32(/* id 3, wireType 2 =*/ 26)
            .string(message.propertyCode);
        if (
          message.bukkakuCode != null &&
          Object.hasOwnProperty.call(message, "bukkakuCode")
        )
          writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.bukkakuCode);
        if (
          message.currentForm != null &&
          Object.hasOwnProperty.call(message, "currentForm")
        )
          writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.currentForm);
        if (message.formSubmitted != null && message.formSubmitted.length)
          for (let i = 0; i < message.formSubmitted.length; ++i)
            writer
              .uint32(/* id 6, wireType 2 =*/ 50)
              .string(message.formSubmitted[i]);
        if (message.values != null && message.values.length)
          for (let i = 0; i < message.values.length; ++i)
            $root.vhmformapi.application.SubmitApplicationFormInput.SetupForm.encode(
              message.values[i],
              writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
            ).ldelim();
        if (
          message.brokerAgentName != null &&
          Object.hasOwnProperty.call(message, "brokerAgentName")
        )
          writer
            .uint32(/* id 8, wireType 2 =*/ 66)
            .string(message.brokerAgentName);
        if (
          message.brokerAgentNumber != null &&
          Object.hasOwnProperty.call(message, "brokerAgentNumber")
        )
          writer
            .uint32(/* id 9, wireType 2 =*/ 74)
            .string(message.brokerAgentNumber);
        if (
          message.brokerAgentEmail != null &&
          Object.hasOwnProperty.call(message, "brokerAgentEmail")
        )
          writer
            .uint32(/* id 10, wireType 2 =*/ 82)
            .string(message.brokerAgentEmail);
        if (
          message.brokerShopName != null &&
          Object.hasOwnProperty.call(message, "brokerShopName")
        )
          writer
            .uint32(/* id 11, wireType 2 =*/ 90)
            .string(message.brokerShopName);
        if (
          message.brokerShopAddress != null &&
          Object.hasOwnProperty.call(message, "brokerShopAddress")
        )
          writer
            .uint32(/* id 12, wireType 2 =*/ 98)
            .string(message.brokerShopAddress);
        if (
          message.brokerShopNumber != null &&
          Object.hasOwnProperty.call(message, "brokerShopNumber")
        )
          writer
            .uint32(/* id 13, wireType 2 =*/ 106)
            .string(message.brokerShopNumber);
        if (
          message.brokerCustomerName != null &&
          Object.hasOwnProperty.call(message, "brokerCustomerName")
        )
          writer
            .uint32(/* id 14, wireType 2 =*/ 114)
            .string(message.brokerCustomerName);
        if (
          message.brokerCustomerEmail != null &&
          Object.hasOwnProperty.call(message, "brokerCustomerEmail")
        )
          writer
            .uint32(/* id 15, wireType 2 =*/ 122)
            .string(message.brokerCustomerEmail);
        if (
          message.expiryDate != null &&
          Object.hasOwnProperty.call(message, "expiryDate")
        )
          writer
            .uint32(/* id 16, wireType 2 =*/ 130)
            .string(message.expiryDate);
        if (message.images != null && message.images.length)
          for (let i = 0; i < message.images.length; ++i)
            $root.vhmformapi.application.SubmitApplicationFormInput.Image.encode(
              message.images[i],
              writer.uint32(/* id 17, wireType 2 =*/ 138).fork()
            ).ldelim();
        if (
          message.bukkakuId != null &&
          Object.hasOwnProperty.call(message, "bukkakuId")
        )
          writer.uint32(/* id 18, wireType 2 =*/ 146).string(message.bukkakuId);
        if (
          message.propertyName != null &&
          Object.hasOwnProperty.call(message, "propertyName")
        )
          writer
            .uint32(/* id 19, wireType 2 =*/ 154)
            .string(message.propertyName);
        if (
          message.buildingName != null &&
          Object.hasOwnProperty.call(message, "buildingName")
        )
          writer
            .uint32(/* id 20, wireType 2 =*/ 162)
            .string(message.buildingName);
        if (
          message.roomNumber != null &&
          Object.hasOwnProperty.call(message, "roomNumber")
        )
          writer
            .uint32(/* id 21, wireType 2 =*/ 170)
            .string(message.roomNumber);
        return writer;
      };

      /**
       * Decodes a SubmitApplicationFormInput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.application.SubmitApplicationFormInput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.application.SubmitApplicationFormInput} SubmitApplicationFormInput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      SubmitApplicationFormInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message =
            new $root.vhmformapi.application.SubmitApplicationFormInput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.leadId = reader.string();
              break;
            }
            case 2: {
              message.language = reader.string();
              break;
            }
            case 3: {
              message.propertyCode = reader.string();
              break;
            }
            case 4: {
              message.bukkakuCode = reader.string();
              break;
            }
            case 5: {
              message.currentForm = reader.string();
              break;
            }
            case 6: {
              if (!(message.formSubmitted && message.formSubmitted.length))
                message.formSubmitted = [];
              message.formSubmitted.push(reader.string());
              break;
            }
            case 7: {
              if (!(message.values && message.values.length))
                message.values = [];
              message.values.push(
                $root.vhmformapi.application.SubmitApplicationFormInput.SetupForm.decode(
                  reader,
                  reader.uint32()
                )
              );
              break;
            }
            case 8: {
              message.brokerAgentName = reader.string();
              break;
            }
            case 9: {
              message.brokerAgentNumber = reader.string();
              break;
            }
            case 10: {
              message.brokerAgentEmail = reader.string();
              break;
            }
            case 11: {
              message.brokerShopName = reader.string();
              break;
            }
            case 12: {
              message.brokerShopAddress = reader.string();
              break;
            }
            case 13: {
              message.brokerShopNumber = reader.string();
              break;
            }
            case 14: {
              message.brokerCustomerName = reader.string();
              break;
            }
            case 15: {
              message.brokerCustomerEmail = reader.string();
              break;
            }
            case 16: {
              message.expiryDate = reader.string();
              break;
            }
            case 17: {
              if (!(message.images && message.images.length))
                message.images = [];
              message.images.push(
                $root.vhmformapi.application.SubmitApplicationFormInput.Image.decode(
                  reader,
                  reader.uint32()
                )
              );
              break;
            }
            case 18: {
              message.bukkakuId = reader.string();
              break;
            }
            case 19: {
              message.propertyName = reader.string();
              break;
            }
            case 20: {
              message.buildingName = reader.string();
              break;
            }
            case 21: {
              message.roomNumber = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      SubmitApplicationFormInput.SetupForm = (function () {
        /**
         * Properties of a SetupForm.
         * @memberof vhmformapi.application.SubmitApplicationFormInput
         * @interface ISetupForm
         * @property {string|null} [name] SetupForm name
         * @property {Object.<string,string>|null} [value] SetupForm value
         */

        /**
         * Constructs a new SetupForm.
         * @memberof vhmformapi.application.SubmitApplicationFormInput
         * @classdesc Represents a SetupForm.
         * @implements ISetupForm
         * @constructor
         * @param {vhmformapi.application.SubmitApplicationFormInput.ISetupForm=} [properties] Properties to set
         */
        function SetupForm(properties) {
          this.value = {};
          if (properties)
            for (
              let keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * SetupForm name.
         * @member {string} name
         * @memberof vhmformapi.application.SubmitApplicationFormInput.SetupForm
         * @instance
         */
        SetupForm.prototype.name = "";

        /**
         * SetupForm value.
         * @member {Object.<string,string>} value
         * @memberof vhmformapi.application.SubmitApplicationFormInput.SetupForm
         * @instance
         */
        SetupForm.prototype.value = $util.emptyObject;

        /**
         * Creates a new SetupForm instance using the specified properties.
         * @function create
         * @memberof vhmformapi.application.SubmitApplicationFormInput.SetupForm
         * @static
         * @param {vhmformapi.application.SubmitApplicationFormInput.ISetupForm=} [properties] Properties to set
         * @returns {vhmformapi.application.SubmitApplicationFormInput.SetupForm} SetupForm instance
         */
        SetupForm.create = function create(properties) {
          return new SetupForm(properties);
        };

        /**
         * Encodes the specified SetupForm message. Does not implicitly {@link vhmformapi.application.SubmitApplicationFormInput.SetupForm.verify|verify} messages.
         * @function encode
         * @memberof vhmformapi.application.SubmitApplicationFormInput.SetupForm
         * @static
         * @param {vhmformapi.application.SubmitApplicationFormInput.ISetupForm} message SetupForm message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetupForm.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.name != null &&
            Object.hasOwnProperty.call(message, "name")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (
            message.value != null &&
            Object.hasOwnProperty.call(message, "value")
          )
            for (
              let keys = Object.keys(message.value), i = 0;
              i < keys.length;
              ++i
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .fork()
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(keys[i])
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.value[keys[i]])
                .ldelim();
          return writer;
        };

        /**
         * Decodes a SetupForm message from the specified reader or buffer.
         * @function decode
         * @memberof vhmformapi.application.SubmitApplicationFormInput.SetupForm
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {vhmformapi.application.SubmitApplicationFormInput.SetupForm} SetupForm
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetupForm.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length,
            message =
              new $root.vhmformapi.application.SubmitApplicationFormInput.SetupForm(),
            key,
            value;
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1: {
                message.name = reader.string();
                break;
              }
              case 2: {
                if (message.value === $util.emptyObject) message.value = {};
                let end2 = reader.uint32() + reader.pos;
                key = "";
                value = "";
                while (reader.pos < end2) {
                  let tag2 = reader.uint32();
                  switch (tag2 >>> 3) {
                    case 1:
                      key = reader.string();
                      break;
                    case 2:
                      value = reader.string();
                      break;
                    default:
                      reader.skipType(tag2 & 7);
                      break;
                  }
                }
                message.value[key] = value;
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        return SetupForm;
      })();

      SubmitApplicationFormInput.Image = (function () {
        /**
         * Properties of an Image.
         * @memberof vhmformapi.application.SubmitApplicationFormInput
         * @interface IImage
         * @property {string|null} [name] Image name
         * @property {string|null} [type] Image type
         * @property {string|null} [position] Image position
         */

        /**
         * Constructs a new Image.
         * @memberof vhmformapi.application.SubmitApplicationFormInput
         * @classdesc Represents an Image.
         * @implements IImage
         * @constructor
         * @param {vhmformapi.application.SubmitApplicationFormInput.IImage=} [properties] Properties to set
         */
        function Image(properties) {
          if (properties)
            for (
              let keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Image name.
         * @member {string} name
         * @memberof vhmformapi.application.SubmitApplicationFormInput.Image
         * @instance
         */
        Image.prototype.name = "";

        /**
         * Image type.
         * @member {string} type
         * @memberof vhmformapi.application.SubmitApplicationFormInput.Image
         * @instance
         */
        Image.prototype.type = "";

        /**
         * Image position.
         * @member {string} position
         * @memberof vhmformapi.application.SubmitApplicationFormInput.Image
         * @instance
         */
        Image.prototype.position = "";

        /**
         * Creates a new Image instance using the specified properties.
         * @function create
         * @memberof vhmformapi.application.SubmitApplicationFormInput.Image
         * @static
         * @param {vhmformapi.application.SubmitApplicationFormInput.IImage=} [properties] Properties to set
         * @returns {vhmformapi.application.SubmitApplicationFormInput.Image} Image instance
         */
        Image.create = function create(properties) {
          return new Image(properties);
        };

        /**
         * Encodes the specified Image message. Does not implicitly {@link vhmformapi.application.SubmitApplicationFormInput.Image.verify|verify} messages.
         * @function encode
         * @memberof vhmformapi.application.SubmitApplicationFormInput.Image
         * @static
         * @param {vhmformapi.application.SubmitApplicationFormInput.IImage} message Image message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Image.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.name != null &&
            Object.hasOwnProperty.call(message, "name")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (
            message.type != null &&
            Object.hasOwnProperty.call(message, "type")
          )
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.type);
          if (
            message.position != null &&
            Object.hasOwnProperty.call(message, "position")
          )
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.position);
          return writer;
        };

        /**
         * Decodes an Image message from the specified reader or buffer.
         * @function decode
         * @memberof vhmformapi.application.SubmitApplicationFormInput.Image
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {vhmformapi.application.SubmitApplicationFormInput.Image} Image
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Image.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length,
            message =
              new $root.vhmformapi.application.SubmitApplicationFormInput.Image();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1: {
                message.name = reader.string();
                break;
              }
              case 2: {
                message.type = reader.string();
                break;
              }
              case 3: {
                message.position = reader.string();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        return Image;
      })();

      return SubmitApplicationFormInput;
    })();

    application.SubmitApplicationFormOutput = (function () {
      /**
       * Properties of a SubmitApplicationFormOutput.
       * @memberof vhmformapi.application
       * @interface ISubmitApplicationFormOutput
       * @property {string|null} [leadId] SubmitApplicationFormOutput leadId
       * @property {string|null} [pdfUrl] SubmitApplicationFormOutput pdfUrl
       */

      /**
       * Constructs a new SubmitApplicationFormOutput.
       * @memberof vhmformapi.application
       * @classdesc Represents a SubmitApplicationFormOutput.
       * @implements ISubmitApplicationFormOutput
       * @constructor
       * @param {vhmformapi.application.ISubmitApplicationFormOutput=} [properties] Properties to set
       */
      function SubmitApplicationFormOutput(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * SubmitApplicationFormOutput leadId.
       * @member {string} leadId
       * @memberof vhmformapi.application.SubmitApplicationFormOutput
       * @instance
       */
      SubmitApplicationFormOutput.prototype.leadId = "";

      /**
       * SubmitApplicationFormOutput pdfUrl.
       * @member {string} pdfUrl
       * @memberof vhmformapi.application.SubmitApplicationFormOutput
       * @instance
       */
      SubmitApplicationFormOutput.prototype.pdfUrl = "";

      /**
       * Creates a new SubmitApplicationFormOutput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.application.SubmitApplicationFormOutput
       * @static
       * @param {vhmformapi.application.ISubmitApplicationFormOutput=} [properties] Properties to set
       * @returns {vhmformapi.application.SubmitApplicationFormOutput} SubmitApplicationFormOutput instance
       */
      SubmitApplicationFormOutput.create = function create(properties) {
        return new SubmitApplicationFormOutput(properties);
      };

      /**
       * Encodes the specified SubmitApplicationFormOutput message. Does not implicitly {@link vhmformapi.application.SubmitApplicationFormOutput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.application.SubmitApplicationFormOutput
       * @static
       * @param {vhmformapi.application.ISubmitApplicationFormOutput} message SubmitApplicationFormOutput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      SubmitApplicationFormOutput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.leadId != null &&
          Object.hasOwnProperty.call(message, "leadId")
        )
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.leadId);
        if (
          message.pdfUrl != null &&
          Object.hasOwnProperty.call(message, "pdfUrl")
        )
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.pdfUrl);
        return writer;
      };

      /**
       * Decodes a SubmitApplicationFormOutput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.application.SubmitApplicationFormOutput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.application.SubmitApplicationFormOutput} SubmitApplicationFormOutput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      SubmitApplicationFormOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message =
            new $root.vhmformapi.application.SubmitApplicationFormOutput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.leadId = reader.string();
              break;
            }
            case 2: {
              message.pdfUrl = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      return SubmitApplicationFormOutput;
    })();

    application.ApplicationFormService = (function () {
      /**
       * Constructs a new ApplicationFormService service.
       * @memberof vhmformapi.application
       * @classdesc Represents an ApplicationFormService
       * @extends $protobuf.rpc.Service
       * @constructor
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       */
      function ApplicationFormService(
        rpcImpl,
        requestDelimited,
        responseDelimited
      ) {
        $protobuf.rpc.Service.call(
          this,
          rpcImpl,
          requestDelimited,
          responseDelimited
        );
      }

      (ApplicationFormService.prototype = Object.create(
        $protobuf.rpc.Service.prototype
      )).constructor = ApplicationFormService;

      /**
       * Creates new ApplicationFormService service using the specified rpc implementation.
       * @function create
       * @memberof vhmformapi.application.ApplicationFormService
       * @static
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       * @returns {ApplicationFormService} RPC service. Useful where requests and/or responses are streamed.
       */
      ApplicationFormService.create = function create(
        rpcImpl,
        requestDelimited,
        responseDelimited
      ) {
        return new this(rpcImpl, requestDelimited, responseDelimited);
      };

      /**
       * Callback as used by {@link vhmformapi.application.ApplicationFormService#submit}.
       * @memberof vhmformapi.application.ApplicationFormService
       * @typedef SubmitCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {vhmformapi.application.SubmitApplicationFormOutput} [response] SubmitApplicationFormOutput
       */

      /**
       * Calls Submit.
       * @function submit
       * @memberof vhmformapi.application.ApplicationFormService
       * @instance
       * @param {vhmformapi.application.ISubmitApplicationFormInput} request SubmitApplicationFormInput message or plain object
       * @param {vhmformapi.application.ApplicationFormService.SubmitCallback} callback Node-style callback called with the error, if any, and SubmitApplicationFormOutput
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (ApplicationFormService.prototype.submit = function submit(
          request,
          callback
        ) {
          return this.rpcCall(
            submit,
            $root.vhmformapi.application.SubmitApplicationFormInput,
            $root.vhmformapi.application.SubmitApplicationFormOutput,
            request,
            callback
          );
        }),
        "name",
        { value: "Submit" }
      );

      /**
       * Calls Submit.
       * @function submit
       * @memberof vhmformapi.application.ApplicationFormService
       * @instance
       * @param {vhmformapi.application.ISubmitApplicationFormInput} request SubmitApplicationFormInput message or plain object
       * @returns {Promise<vhmformapi.application.SubmitApplicationFormOutput>} Promise
       * @variation 2
       */

      return ApplicationFormService;
    })();

    application.SubmitImageInput = (function () {
      /**
       * Properties of a SubmitImageInput.
       * @memberof vhmformapi.application
       * @interface ISubmitImageInput
       * @property {string|null} [leadId] SubmitImageInput leadId
       * @property {string|null} [name] SubmitImageInput name
       * @property {Uint8Array|null} [data] SubmitImageInput data
       */

      /**
       * Constructs a new SubmitImageInput.
       * @memberof vhmformapi.application
       * @classdesc Represents a SubmitImageInput.
       * @implements ISubmitImageInput
       * @constructor
       * @param {vhmformapi.application.ISubmitImageInput=} [properties] Properties to set
       */
      function SubmitImageInput(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * SubmitImageInput leadId.
       * @member {string} leadId
       * @memberof vhmformapi.application.SubmitImageInput
       * @instance
       */
      SubmitImageInput.prototype.leadId = "";

      /**
       * SubmitImageInput name.
       * @member {string} name
       * @memberof vhmformapi.application.SubmitImageInput
       * @instance
       */
      SubmitImageInput.prototype.name = "";

      /**
       * SubmitImageInput data.
       * @member {Uint8Array} data
       * @memberof vhmformapi.application.SubmitImageInput
       * @instance
       */
      SubmitImageInput.prototype.data = $util.newBuffer([]);

      /**
       * Creates a new SubmitImageInput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.application.SubmitImageInput
       * @static
       * @param {vhmformapi.application.ISubmitImageInput=} [properties] Properties to set
       * @returns {vhmformapi.application.SubmitImageInput} SubmitImageInput instance
       */
      SubmitImageInput.create = function create(properties) {
        return new SubmitImageInput(properties);
      };

      /**
       * Encodes the specified SubmitImageInput message. Does not implicitly {@link vhmformapi.application.SubmitImageInput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.application.SubmitImageInput
       * @static
       * @param {vhmformapi.application.ISubmitImageInput} message SubmitImageInput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      SubmitImageInput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.leadId != null &&
          Object.hasOwnProperty.call(message, "leadId")
        )
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.leadId);
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.name);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
          writer.uint32(/* id 5, wireType 2 =*/ 42).bytes(message.data);
        return writer;
      };

      /**
       * Decodes a SubmitImageInput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.application.SubmitImageInput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.application.SubmitImageInput} SubmitImageInput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      SubmitImageInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.vhmformapi.application.SubmitImageInput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.leadId = reader.string();
              break;
            }
            case 2: {
              message.name = reader.string();
              break;
            }
            case 5: {
              message.data = reader.bytes();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      return SubmitImageInput;
    })();

    application.SubmitImageOutput = (function () {
      /**
       * Properties of a SubmitImageOutput.
       * @memberof vhmformapi.application
       * @interface ISubmitImageOutput
       * @property {string|null} [leadId] SubmitImageOutput leadId
       */

      /**
       * Constructs a new SubmitImageOutput.
       * @memberof vhmformapi.application
       * @classdesc Represents a SubmitImageOutput.
       * @implements ISubmitImageOutput
       * @constructor
       * @param {vhmformapi.application.ISubmitImageOutput=} [properties] Properties to set
       */
      function SubmitImageOutput(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * SubmitImageOutput leadId.
       * @member {string} leadId
       * @memberof vhmformapi.application.SubmitImageOutput
       * @instance
       */
      SubmitImageOutput.prototype.leadId = "";

      /**
       * Creates a new SubmitImageOutput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.application.SubmitImageOutput
       * @static
       * @param {vhmformapi.application.ISubmitImageOutput=} [properties] Properties to set
       * @returns {vhmformapi.application.SubmitImageOutput} SubmitImageOutput instance
       */
      SubmitImageOutput.create = function create(properties) {
        return new SubmitImageOutput(properties);
      };

      /**
       * Encodes the specified SubmitImageOutput message. Does not implicitly {@link vhmformapi.application.SubmitImageOutput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.application.SubmitImageOutput
       * @static
       * @param {vhmformapi.application.ISubmitImageOutput} message SubmitImageOutput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      SubmitImageOutput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.leadId != null &&
          Object.hasOwnProperty.call(message, "leadId")
        )
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.leadId);
        return writer;
      };

      /**
       * Decodes a SubmitImageOutput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.application.SubmitImageOutput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.application.SubmitImageOutput} SubmitImageOutput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      SubmitImageOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.vhmformapi.application.SubmitImageOutput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.leadId = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      return SubmitImageOutput;
    })();

    application.ImageService = (function () {
      /**
       * Constructs a new ImageService service.
       * @memberof vhmformapi.application
       * @classdesc Represents an ImageService
       * @extends $protobuf.rpc.Service
       * @constructor
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       */
      function ImageService(rpcImpl, requestDelimited, responseDelimited) {
        $protobuf.rpc.Service.call(
          this,
          rpcImpl,
          requestDelimited,
          responseDelimited
        );
      }

      (ImageService.prototype = Object.create(
        $protobuf.rpc.Service.prototype
      )).constructor = ImageService;

      /**
       * Creates new ImageService service using the specified rpc implementation.
       * @function create
       * @memberof vhmformapi.application.ImageService
       * @static
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       * @returns {ImageService} RPC service. Useful where requests and/or responses are streamed.
       */
      ImageService.create = function create(
        rpcImpl,
        requestDelimited,
        responseDelimited
      ) {
        return new this(rpcImpl, requestDelimited, responseDelimited);
      };

      /**
       * Callback as used by {@link vhmformapi.application.ImageService#submit}.
       * @memberof vhmformapi.application.ImageService
       * @typedef SubmitCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {vhmformapi.application.SubmitImageOutput} [response] SubmitImageOutput
       */

      /**
       * Calls Submit.
       * @function submit
       * @memberof vhmformapi.application.ImageService
       * @instance
       * @param {vhmformapi.application.ISubmitImageInput} request SubmitImageInput message or plain object
       * @param {vhmformapi.application.ImageService.SubmitCallback} callback Node-style callback called with the error, if any, and SubmitImageOutput
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (ImageService.prototype.submit = function submit(request, callback) {
          return this.rpcCall(
            submit,
            $root.vhmformapi.application.SubmitImageInput,
            $root.vhmformapi.application.SubmitImageOutput,
            request,
            callback
          );
        }),
        "name",
        { value: "Submit" }
      );

      /**
       * Calls Submit.
       * @function submit
       * @memberof vhmformapi.application.ImageService
       * @instance
       * @param {vhmformapi.application.ISubmitImageInput} request SubmitImageInput message or plain object
       * @returns {Promise<vhmformapi.application.SubmitImageOutput>} Promise
       * @variation 2
       */

      return ImageService;
    })();

    application.ErrorMessage = (function () {
      /**
       * Properties of an ErrorMessage.
       * @memberof vhmformapi.application
       * @interface IErrorMessage
       * @property {string|null} [message] ErrorMessage message
       * @property {string|null} [errorCode] ErrorMessage errorCode
       * @property {Array.<string>|null} [fields] ErrorMessage fields
       */

      /**
       * Constructs a new ErrorMessage.
       * @memberof vhmformapi.application
       * @classdesc Represents an ErrorMessage.
       * @implements IErrorMessage
       * @constructor
       * @param {vhmformapi.application.IErrorMessage=} [properties] Properties to set
       */
      function ErrorMessage(properties) {
        this.fields = [];
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * ErrorMessage message.
       * @member {string} message
       * @memberof vhmformapi.application.ErrorMessage
       * @instance
       */
      ErrorMessage.prototype.message = "";

      /**
       * ErrorMessage errorCode.
       * @member {string} errorCode
       * @memberof vhmformapi.application.ErrorMessage
       * @instance
       */
      ErrorMessage.prototype.errorCode = "";

      /**
       * ErrorMessage fields.
       * @member {Array.<string>} fields
       * @memberof vhmformapi.application.ErrorMessage
       * @instance
       */
      ErrorMessage.prototype.fields = $util.emptyArray;

      /**
       * Creates a new ErrorMessage instance using the specified properties.
       * @function create
       * @memberof vhmformapi.application.ErrorMessage
       * @static
       * @param {vhmformapi.application.IErrorMessage=} [properties] Properties to set
       * @returns {vhmformapi.application.ErrorMessage} ErrorMessage instance
       */
      ErrorMessage.create = function create(properties) {
        return new ErrorMessage(properties);
      };

      /**
       * Encodes the specified ErrorMessage message. Does not implicitly {@link vhmformapi.application.ErrorMessage.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.application.ErrorMessage
       * @static
       * @param {vhmformapi.application.IErrorMessage} message ErrorMessage message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      ErrorMessage.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.message != null &&
          Object.hasOwnProperty.call(message, "message")
        )
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.message);
        if (
          message.errorCode != null &&
          Object.hasOwnProperty.call(message, "errorCode")
        )
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.errorCode);
        if (message.fields != null && message.fields.length)
          for (let i = 0; i < message.fields.length; ++i)
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.fields[i]);
        return writer;
      };

      /**
       * Decodes an ErrorMessage message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.application.ErrorMessage
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.application.ErrorMessage} ErrorMessage
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      ErrorMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.vhmformapi.application.ErrorMessage();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.message = reader.string();
              break;
            }
            case 2: {
              message.errorCode = reader.string();
              break;
            }
            case 3: {
              if (!(message.fields && message.fields.length))
                message.fields = [];
              message.fields.push(reader.string());
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      return ErrorMessage;
    })();

    return application;
  })();

  vhmformapi.autodebit = (function () {
    /**
     * Namespace autodebit.
     * @memberof vhmformapi
     * @namespace
     */
    const autodebit = {};

    /**
     * AuthErrorCode enum.
     * @name vhmformapi.autodebit.AuthErrorCode
     * @enum {number}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} APPLICATION_NUMBER_OR_PHONE_NOT_MATCH=1 APPLICATION_NUMBER_OR_PHONE_NOT_MATCH value
     * @property {number} APLUS_REGISTRATION_HAS_BEEN_COMPLETED=2 APLUS_REGISTRATION_HAS_BEEN_COMPLETED value
     */
    autodebit.AuthErrorCode = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = "UNKNOWN")] = 0;
      values[(valuesById[1] = "APPLICATION_NUMBER_OR_PHONE_NOT_MATCH")] = 1;
      values[(valuesById[2] = "APLUS_REGISTRATION_HAS_BEEN_COMPLETED")] = 2;
      return values;
    })();

    autodebit.SubmitLoginInput = (function () {
      /**
       * Properties of a SubmitLoginInput.
       * @memberof vhmformapi.autodebit
       * @interface ISubmitLoginInput
       * @property {string|null} [applicationNumber] SubmitLoginInput applicationNumber
       * @property {string|null} [phone] SubmitLoginInput phone
       * @property {string|null} [name] SubmitLoginInput name
       * @property {string|null} [dateOfBirth] SubmitLoginInput dateOfBirth
       * @property {boolean|null} [isCorporate] SubmitLoginInput isCorporate
       * @property {vhmptypes.Language|null} [lang] SubmitLoginInput lang
       */

      /**
       * Constructs a new SubmitLoginInput.
       * @memberof vhmformapi.autodebit
       * @classdesc Represents a SubmitLoginInput.
       * @implements ISubmitLoginInput
       * @constructor
       * @param {vhmformapi.autodebit.ISubmitLoginInput=} [properties] Properties to set
       */
      function SubmitLoginInput(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * SubmitLoginInput applicationNumber.
       * @member {string} applicationNumber
       * @memberof vhmformapi.autodebit.SubmitLoginInput
       * @instance
       */
      SubmitLoginInput.prototype.applicationNumber = "";

      /**
       * SubmitLoginInput phone.
       * @member {string} phone
       * @memberof vhmformapi.autodebit.SubmitLoginInput
       * @instance
       */
      SubmitLoginInput.prototype.phone = "";

      /**
       * SubmitLoginInput name.
       * @member {string} name
       * @memberof vhmformapi.autodebit.SubmitLoginInput
       * @instance
       */
      SubmitLoginInput.prototype.name = "";

      /**
       * SubmitLoginInput dateOfBirth.
       * @member {string} dateOfBirth
       * @memberof vhmformapi.autodebit.SubmitLoginInput
       * @instance
       */
      SubmitLoginInput.prototype.dateOfBirth = "";

      /**
       * SubmitLoginInput isCorporate.
       * @member {boolean} isCorporate
       * @memberof vhmformapi.autodebit.SubmitLoginInput
       * @instance
       */
      SubmitLoginInput.prototype.isCorporate = false;

      /**
       * SubmitLoginInput lang.
       * @member {vhmptypes.Language} lang
       * @memberof vhmformapi.autodebit.SubmitLoginInput
       * @instance
       */
      SubmitLoginInput.prototype.lang = 0;

      /**
       * Creates a new SubmitLoginInput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.autodebit.SubmitLoginInput
       * @static
       * @param {vhmformapi.autodebit.ISubmitLoginInput=} [properties] Properties to set
       * @returns {vhmformapi.autodebit.SubmitLoginInput} SubmitLoginInput instance
       */
      SubmitLoginInput.create = function create(properties) {
        return new SubmitLoginInput(properties);
      };

      /**
       * Encodes the specified SubmitLoginInput message. Does not implicitly {@link vhmformapi.autodebit.SubmitLoginInput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.autodebit.SubmitLoginInput
       * @static
       * @param {vhmformapi.autodebit.ISubmitLoginInput} message SubmitLoginInput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      SubmitLoginInput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.applicationNumber != null &&
          Object.hasOwnProperty.call(message, "applicationNumber")
        )
          writer
            .uint32(/* id 1, wireType 2 =*/ 10)
            .string(message.applicationNumber);
        if (
          message.phone != null &&
          Object.hasOwnProperty.call(message, "phone")
        )
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.phone);
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.name);
        if (
          message.dateOfBirth != null &&
          Object.hasOwnProperty.call(message, "dateOfBirth")
        )
          writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.dateOfBirth);
        if (
          message.isCorporate != null &&
          Object.hasOwnProperty.call(message, "isCorporate")
        )
          writer.uint32(/* id 5, wireType 0 =*/ 40).bool(message.isCorporate);
        if (message.lang != null && Object.hasOwnProperty.call(message, "lang"))
          writer.uint32(/* id 6, wireType 0 =*/ 48).int32(message.lang);
        return writer;
      };

      /**
       * Decodes a SubmitLoginInput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.autodebit.SubmitLoginInput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.autodebit.SubmitLoginInput} SubmitLoginInput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      SubmitLoginInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.vhmformapi.autodebit.SubmitLoginInput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.applicationNumber = reader.string();
              break;
            }
            case 2: {
              message.phone = reader.string();
              break;
            }
            case 3: {
              message.name = reader.string();
              break;
            }
            case 4: {
              message.dateOfBirth = reader.string();
              break;
            }
            case 5: {
              message.isCorporate = reader.bool();
              break;
            }
            case 6: {
              message.lang = reader.int32();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      return SubmitLoginInput;
    })();

    autodebit.SubmitLoginOutput = (function () {
      /**
       * Properties of a SubmitLoginOutput.
       * @memberof vhmformapi.autodebit
       * @interface ISubmitLoginOutput
       * @property {string|null} [kfrequest] SubmitLoginOutput kfrequest
       * @property {string|null} [url] SubmitLoginOutput url
       * @property {number|null} [status] SubmitLoginOutput status
       * @property {string|null} [errorMessage] SubmitLoginOutput errorMessage
       */

      /**
       * Constructs a new SubmitLoginOutput.
       * @memberof vhmformapi.autodebit
       * @classdesc Represents a SubmitLoginOutput.
       * @implements ISubmitLoginOutput
       * @constructor
       * @param {vhmformapi.autodebit.ISubmitLoginOutput=} [properties] Properties to set
       */
      function SubmitLoginOutput(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * SubmitLoginOutput kfrequest.
       * @member {string} kfrequest
       * @memberof vhmformapi.autodebit.SubmitLoginOutput
       * @instance
       */
      SubmitLoginOutput.prototype.kfrequest = "";

      /**
       * SubmitLoginOutput url.
       * @member {string} url
       * @memberof vhmformapi.autodebit.SubmitLoginOutput
       * @instance
       */
      SubmitLoginOutput.prototype.url = "";

      /**
       * SubmitLoginOutput status.
       * @member {number} status
       * @memberof vhmformapi.autodebit.SubmitLoginOutput
       * @instance
       */
      SubmitLoginOutput.prototype.status = 0;

      /**
       * SubmitLoginOutput errorMessage.
       * @member {string} errorMessage
       * @memberof vhmformapi.autodebit.SubmitLoginOutput
       * @instance
       */
      SubmitLoginOutput.prototype.errorMessage = "";

      /**
       * Creates a new SubmitLoginOutput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.autodebit.SubmitLoginOutput
       * @static
       * @param {vhmformapi.autodebit.ISubmitLoginOutput=} [properties] Properties to set
       * @returns {vhmformapi.autodebit.SubmitLoginOutput} SubmitLoginOutput instance
       */
      SubmitLoginOutput.create = function create(properties) {
        return new SubmitLoginOutput(properties);
      };

      /**
       * Encodes the specified SubmitLoginOutput message. Does not implicitly {@link vhmformapi.autodebit.SubmitLoginOutput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.autodebit.SubmitLoginOutput
       * @static
       * @param {vhmformapi.autodebit.ISubmitLoginOutput} message SubmitLoginOutput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      SubmitLoginOutput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.kfrequest != null &&
          Object.hasOwnProperty.call(message, "kfrequest")
        )
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.kfrequest);
        if (message.url != null && Object.hasOwnProperty.call(message, "url"))
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.url);
        if (
          message.status != null &&
          Object.hasOwnProperty.call(message, "status")
        )
          writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.status);
        if (
          message.errorMessage != null &&
          Object.hasOwnProperty.call(message, "errorMessage")
        )
          writer
            .uint32(/* id 4, wireType 2 =*/ 34)
            .string(message.errorMessage);
        return writer;
      };

      /**
       * Decodes a SubmitLoginOutput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.autodebit.SubmitLoginOutput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.autodebit.SubmitLoginOutput} SubmitLoginOutput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      SubmitLoginOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.vhmformapi.autodebit.SubmitLoginOutput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.kfrequest = reader.string();
              break;
            }
            case 2: {
              message.url = reader.string();
              break;
            }
            case 3: {
              message.status = reader.int32();
              break;
            }
            case 4: {
              message.errorMessage = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      return SubmitLoginOutput;
    })();

    autodebit.AutoDebitFormService = (function () {
      /**
       * Constructs a new AutoDebitFormService service.
       * @memberof vhmformapi.autodebit
       * @classdesc Represents an AutoDebitFormService
       * @extends $protobuf.rpc.Service
       * @constructor
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       */
      function AutoDebitFormService(
        rpcImpl,
        requestDelimited,
        responseDelimited
      ) {
        $protobuf.rpc.Service.call(
          this,
          rpcImpl,
          requestDelimited,
          responseDelimited
        );
      }

      (AutoDebitFormService.prototype = Object.create(
        $protobuf.rpc.Service.prototype
      )).constructor = AutoDebitFormService;

      /**
       * Creates new AutoDebitFormService service using the specified rpc implementation.
       * @function create
       * @memberof vhmformapi.autodebit.AutoDebitFormService
       * @static
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       * @returns {AutoDebitFormService} RPC service. Useful where requests and/or responses are streamed.
       */
      AutoDebitFormService.create = function create(
        rpcImpl,
        requestDelimited,
        responseDelimited
      ) {
        return new this(rpcImpl, requestDelimited, responseDelimited);
      };

      /**
       * Callback as used by {@link vhmformapi.autodebit.AutoDebitFormService#submitLogin}.
       * @memberof vhmformapi.autodebit.AutoDebitFormService
       * @typedef SubmitLoginCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {vhmformapi.autodebit.SubmitLoginOutput} [response] SubmitLoginOutput
       */

      /**
       * Calls SubmitLogin.
       * @function submitLogin
       * @memberof vhmformapi.autodebit.AutoDebitFormService
       * @instance
       * @param {vhmformapi.autodebit.ISubmitLoginInput} request SubmitLoginInput message or plain object
       * @param {vhmformapi.autodebit.AutoDebitFormService.SubmitLoginCallback} callback Node-style callback called with the error, if any, and SubmitLoginOutput
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (AutoDebitFormService.prototype.submitLogin = function submitLogin(
          request,
          callback
        ) {
          return this.rpcCall(
            submitLogin,
            $root.vhmformapi.autodebit.SubmitLoginInput,
            $root.vhmformapi.autodebit.SubmitLoginOutput,
            request,
            callback
          );
        }),
        "name",
        { value: "SubmitLogin" }
      );

      /**
       * Calls SubmitLogin.
       * @function submitLogin
       * @memberof vhmformapi.autodebit.AutoDebitFormService
       * @instance
       * @param {vhmformapi.autodebit.ISubmitLoginInput} request SubmitLoginInput message or plain object
       * @returns {Promise<vhmformapi.autodebit.SubmitLoginOutput>} Promise
       * @variation 2
       */

      return AutoDebitFormService;
    })();

    return autodebit;
  })();

  vhmformapi.bookvisit = (function () {
    /**
     * Namespace bookvisit.
     * @memberof vhmformapi
     * @namespace
     */
    const bookvisit = {};

    /**
     * ErrorCode enum.
     * @name vhmformapi.bookvisit.ErrorCode
     * @enum {number}
     * @property {number} CURRENT_URL_IS_EMPTY=0 CURRENT_URL_IS_EMPTY value
     * @property {number} INITIAL_ACCESS_URL_IS_EMPTY=1 INITIAL_ACCESS_URL_IS_EMPTY value
     * @property {number} PROPERTY_NOT_FOUND=2 PROPERTY_NOT_FOUND value
     * @property {number} ROOM_NOT_FOUND=3 ROOM_NOT_FOUND value
     * @property {number} RECORD_ID_IS_EMPTY=4 RECORD_ID_IS_EMPTY value
     * @property {number} ModeOfTransportation_IS_INVALID=5 ModeOfTransportation_IS_INVALID value
     * @property {number} INVALID_EMAIL_ADDRESS=6 INVALID_EMAIL_ADDRESS value
     * @property {number} INVALID_CONFIRM_EMAIL_ADDRESS=7 INVALID_CONFIRM_EMAIL_ADDRESS value
     * @property {number} MAIL_AND_CONFIRM_EMAIL_ADDRESS_MISMATCH=8 MAIL_AND_CONFIRM_EMAIL_ADDRESS_MISMATCH value
     */
    bookvisit.ErrorCode = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = "CURRENT_URL_IS_EMPTY")] = 0;
      values[(valuesById[1] = "INITIAL_ACCESS_URL_IS_EMPTY")] = 1;
      values[(valuesById[2] = "PROPERTY_NOT_FOUND")] = 2;
      values[(valuesById[3] = "ROOM_NOT_FOUND")] = 3;
      values[(valuesById[4] = "RECORD_ID_IS_EMPTY")] = 4;
      values[(valuesById[5] = "ModeOfTransportation_IS_INVALID")] = 5;
      values[(valuesById[6] = "INVALID_EMAIL_ADDRESS")] = 6;
      values[(valuesById[7] = "INVALID_CONFIRM_EMAIL_ADDRESS")] = 7;
      values[(valuesById[8] = "MAIL_AND_CONFIRM_EMAIL_ADDRESS_MISMATCH")] = 8;
      return values;
    })();

    bookvisit.SubmitBookingInput = (function () {
      /**
       * Properties of a SubmitBookingInput.
       * @memberof vhmformapi.bookvisit
       * @interface ISubmitBookingInput
       * @property {vhmptypes.Language|null} [lang] SubmitBookingInput lang
       * @property {number|null} [propertyId] SubmitBookingInput propertyId
       * @property {string|null} [roomId] SubmitBookingInput roomId
       * @property {string|null} [name] SubmitBookingInput name
       * @property {string|null} [nameKana] SubmitBookingInput nameKana
       * @property {string|null} [email] SubmitBookingInput email
       * @property {string|null} [telephone] SubmitBookingInput telephone
       * @property {string|null} [message] SubmitBookingInput message
       * @property {string|null} [currentUrl] SubmitBookingInput currentUrl
       * @property {string|null} [initialAccessUrl] SubmitBookingInput initialAccessUrl
       * @property {string|null} [visitDate_1] SubmitBookingInput visitDate_1
       * @property {string|null} [visitDate_2] SubmitBookingInput visitDate_2
       * @property {string|null} [visitDate_3] SubmitBookingInput visitDate_3
       * @property {boolean|null} [japaneseAttend] SubmitBookingInput japaneseAttend
       * @property {string|null} [recordId] SubmitBookingInput recordId
       * @property {string|null} [modeOfTransportation] SubmitBookingInput modeOfTransportation
       * @property {string|null} [confirmEmailAddress] SubmitBookingInput confirmEmailAddress
       * @property {string|null} [testGroup] SubmitBookingInput testGroup
       */

      /**
       * Constructs a new SubmitBookingInput.
       * @memberof vhmformapi.bookvisit
       * @classdesc Represents a SubmitBookingInput.
       * @implements ISubmitBookingInput
       * @constructor
       * @param {vhmformapi.bookvisit.ISubmitBookingInput=} [properties] Properties to set
       */
      function SubmitBookingInput(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * SubmitBookingInput lang.
       * @member {vhmptypes.Language} lang
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.lang = 0;

      /**
       * SubmitBookingInput propertyId.
       * @member {number} propertyId
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.propertyId = 0;

      /**
       * SubmitBookingInput roomId.
       * @member {string} roomId
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.roomId = "";

      /**
       * SubmitBookingInput name.
       * @member {string} name
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.name = "";

      /**
       * SubmitBookingInput nameKana.
       * @member {string} nameKana
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.nameKana = "";

      /**
       * SubmitBookingInput email.
       * @member {string} email
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.email = "";

      /**
       * SubmitBookingInput telephone.
       * @member {string} telephone
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.telephone = "";

      /**
       * SubmitBookingInput message.
       * @member {string} message
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.message = "";

      /**
       * SubmitBookingInput currentUrl.
       * @member {string} currentUrl
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.currentUrl = "";

      /**
       * SubmitBookingInput initialAccessUrl.
       * @member {string} initialAccessUrl
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.initialAccessUrl = "";

      /**
       * SubmitBookingInput visitDate_1.
       * @member {string} visitDate_1
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.visitDate_1 = "";

      /**
       * SubmitBookingInput visitDate_2.
       * @member {string} visitDate_2
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.visitDate_2 = "";

      /**
       * SubmitBookingInput visitDate_3.
       * @member {string} visitDate_3
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.visitDate_3 = "";

      /**
       * SubmitBookingInput japaneseAttend.
       * @member {boolean} japaneseAttend
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.japaneseAttend = false;

      /**
       * SubmitBookingInput recordId.
       * @member {string} recordId
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.recordId = "";

      /**
       * SubmitBookingInput modeOfTransportation.
       * @member {string} modeOfTransportation
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.modeOfTransportation = "";

      /**
       * SubmitBookingInput confirmEmailAddress.
       * @member {string} confirmEmailAddress
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.confirmEmailAddress = "";

      /**
       * SubmitBookingInput testGroup.
       * @member {string} testGroup
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @instance
       */
      SubmitBookingInput.prototype.testGroup = "";

      /**
       * Creates a new SubmitBookingInput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @static
       * @param {vhmformapi.bookvisit.ISubmitBookingInput=} [properties] Properties to set
       * @returns {vhmformapi.bookvisit.SubmitBookingInput} SubmitBookingInput instance
       */
      SubmitBookingInput.create = function create(properties) {
        return new SubmitBookingInput(properties);
      };

      /**
       * Encodes the specified SubmitBookingInput message. Does not implicitly {@link vhmformapi.bookvisit.SubmitBookingInput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @static
       * @param {vhmformapi.bookvisit.ISubmitBookingInput} message SubmitBookingInput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      SubmitBookingInput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.lang != null && Object.hasOwnProperty.call(message, "lang"))
          writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.lang);
        if (
          message.propertyId != null &&
          Object.hasOwnProperty.call(message, "propertyId")
        )
          writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.propertyId);
        if (
          message.roomId != null &&
          Object.hasOwnProperty.call(message, "roomId")
        )
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.roomId);
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
          writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.name);
        if (
          message.nameKana != null &&
          Object.hasOwnProperty.call(message, "nameKana")
        )
          writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.nameKana);
        if (
          message.email != null &&
          Object.hasOwnProperty.call(message, "email")
        )
          writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.email);
        if (
          message.telephone != null &&
          Object.hasOwnProperty.call(message, "telephone")
        )
          writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.telephone);
        if (
          message.message != null &&
          Object.hasOwnProperty.call(message, "message")
        )
          writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.message);
        if (
          message.currentUrl != null &&
          Object.hasOwnProperty.call(message, "currentUrl")
        )
          writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.currentUrl);
        if (
          message.initialAccessUrl != null &&
          Object.hasOwnProperty.call(message, "initialAccessUrl")
        )
          writer
            .uint32(/* id 10, wireType 2 =*/ 82)
            .string(message.initialAccessUrl);
        if (
          message.visitDate_1 != null &&
          Object.hasOwnProperty.call(message, "visitDate_1")
        )
          writer
            .uint32(/* id 11, wireType 2 =*/ 90)
            .string(message.visitDate_1);
        if (
          message.visitDate_2 != null &&
          Object.hasOwnProperty.call(message, "visitDate_2")
        )
          writer
            .uint32(/* id 12, wireType 2 =*/ 98)
            .string(message.visitDate_2);
        if (
          message.visitDate_3 != null &&
          Object.hasOwnProperty.call(message, "visitDate_3")
        )
          writer
            .uint32(/* id 13, wireType 2 =*/ 106)
            .string(message.visitDate_3);
        if (
          message.japaneseAttend != null &&
          Object.hasOwnProperty.call(message, "japaneseAttend")
        )
          writer
            .uint32(/* id 14, wireType 0 =*/ 112)
            .bool(message.japaneseAttend);
        if (
          message.recordId != null &&
          Object.hasOwnProperty.call(message, "recordId")
        )
          writer.uint32(/* id 15, wireType 2 =*/ 122).string(message.recordId);
        if (
          message.modeOfTransportation != null &&
          Object.hasOwnProperty.call(message, "modeOfTransportation")
        )
          writer
            .uint32(/* id 16, wireType 2 =*/ 130)
            .string(message.modeOfTransportation);
        if (
          message.confirmEmailAddress != null &&
          Object.hasOwnProperty.call(message, "confirmEmailAddress")
        )
          writer
            .uint32(/* id 17, wireType 2 =*/ 138)
            .string(message.confirmEmailAddress);
        if (
          message.testGroup != null &&
          Object.hasOwnProperty.call(message, "testGroup")
        )
          writer.uint32(/* id 18, wireType 2 =*/ 146).string(message.testGroup);
        return writer;
      };

      /**
       * Decodes a SubmitBookingInput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.bookvisit.SubmitBookingInput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.bookvisit.SubmitBookingInput} SubmitBookingInput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      SubmitBookingInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.vhmformapi.bookvisit.SubmitBookingInput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.lang = reader.int32();
              break;
            }
            case 2: {
              message.propertyId = reader.int32();
              break;
            }
            case 3: {
              message.roomId = reader.string();
              break;
            }
            case 4: {
              message.name = reader.string();
              break;
            }
            case 5: {
              message.nameKana = reader.string();
              break;
            }
            case 6: {
              message.email = reader.string();
              break;
            }
            case 7: {
              message.telephone = reader.string();
              break;
            }
            case 8: {
              message.message = reader.string();
              break;
            }
            case 9: {
              message.currentUrl = reader.string();
              break;
            }
            case 10: {
              message.initialAccessUrl = reader.string();
              break;
            }
            case 11: {
              message.visitDate_1 = reader.string();
              break;
            }
            case 12: {
              message.visitDate_2 = reader.string();
              break;
            }
            case 13: {
              message.visitDate_3 = reader.string();
              break;
            }
            case 14: {
              message.japaneseAttend = reader.bool();
              break;
            }
            case 15: {
              message.recordId = reader.string();
              break;
            }
            case 16: {
              message.modeOfTransportation = reader.string();
              break;
            }
            case 17: {
              message.confirmEmailAddress = reader.string();
              break;
            }
            case 18: {
              message.testGroup = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      return SubmitBookingInput;
    })();

    bookvisit.SubmitBookingOutput = (function () {
      /**
       * Properties of a SubmitBookingOutput.
       * @memberof vhmformapi.bookvisit
       * @interface ISubmitBookingOutput
       * @property {string|null} [redirectUrl] SubmitBookingOutput redirectUrl
       * @property {string|null} [recordId] SubmitBookingOutput recordId
       */

      /**
       * Constructs a new SubmitBookingOutput.
       * @memberof vhmformapi.bookvisit
       * @classdesc Represents a SubmitBookingOutput.
       * @implements ISubmitBookingOutput
       * @constructor
       * @param {vhmformapi.bookvisit.ISubmitBookingOutput=} [properties] Properties to set
       */
      function SubmitBookingOutput(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * SubmitBookingOutput redirectUrl.
       * @member {string} redirectUrl
       * @memberof vhmformapi.bookvisit.SubmitBookingOutput
       * @instance
       */
      SubmitBookingOutput.prototype.redirectUrl = "";

      /**
       * SubmitBookingOutput recordId.
       * @member {string} recordId
       * @memberof vhmformapi.bookvisit.SubmitBookingOutput
       * @instance
       */
      SubmitBookingOutput.prototype.recordId = "";

      /**
       * Creates a new SubmitBookingOutput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.bookvisit.SubmitBookingOutput
       * @static
       * @param {vhmformapi.bookvisit.ISubmitBookingOutput=} [properties] Properties to set
       * @returns {vhmformapi.bookvisit.SubmitBookingOutput} SubmitBookingOutput instance
       */
      SubmitBookingOutput.create = function create(properties) {
        return new SubmitBookingOutput(properties);
      };

      /**
       * Encodes the specified SubmitBookingOutput message. Does not implicitly {@link vhmformapi.bookvisit.SubmitBookingOutput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.bookvisit.SubmitBookingOutput
       * @static
       * @param {vhmformapi.bookvisit.ISubmitBookingOutput} message SubmitBookingOutput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      SubmitBookingOutput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.redirectUrl != null &&
          Object.hasOwnProperty.call(message, "redirectUrl")
        )
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.redirectUrl);
        if (
          message.recordId != null &&
          Object.hasOwnProperty.call(message, "recordId")
        )
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.recordId);
        return writer;
      };

      /**
       * Decodes a SubmitBookingOutput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.bookvisit.SubmitBookingOutput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.bookvisit.SubmitBookingOutput} SubmitBookingOutput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      SubmitBookingOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.vhmformapi.bookvisit.SubmitBookingOutput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.redirectUrl = reader.string();
              break;
            }
            case 2: {
              message.recordId = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      return SubmitBookingOutput;
    })();

    bookvisit.BookVisitFormService = (function () {
      /**
       * Constructs a new BookVisitFormService service.
       * @memberof vhmformapi.bookvisit
       * @classdesc Represents a BookVisitFormService
       * @extends $protobuf.rpc.Service
       * @constructor
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       */
      function BookVisitFormService(
        rpcImpl,
        requestDelimited,
        responseDelimited
      ) {
        $protobuf.rpc.Service.call(
          this,
          rpcImpl,
          requestDelimited,
          responseDelimited
        );
      }

      (BookVisitFormService.prototype = Object.create(
        $protobuf.rpc.Service.prototype
      )).constructor = BookVisitFormService;

      /**
       * Creates new BookVisitFormService service using the specified rpc implementation.
       * @function create
       * @memberof vhmformapi.bookvisit.BookVisitFormService
       * @static
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       * @returns {BookVisitFormService} RPC service. Useful where requests and/or responses are streamed.
       */
      BookVisitFormService.create = function create(
        rpcImpl,
        requestDelimited,
        responseDelimited
      ) {
        return new this(rpcImpl, requestDelimited, responseDelimited);
      };

      /**
       * Callback as used by {@link vhmformapi.bookvisit.BookVisitFormService#submitBooking}.
       * @memberof vhmformapi.bookvisit.BookVisitFormService
       * @typedef SubmitBookingCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {vhmformapi.bookvisit.SubmitBookingOutput} [response] SubmitBookingOutput
       */

      /**
       * Calls SubmitBooking.
       * @function submitBooking
       * @memberof vhmformapi.bookvisit.BookVisitFormService
       * @instance
       * @param {vhmformapi.bookvisit.ISubmitBookingInput} request SubmitBookingInput message or plain object
       * @param {vhmformapi.bookvisit.BookVisitFormService.SubmitBookingCallback} callback Node-style callback called with the error, if any, and SubmitBookingOutput
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (BookVisitFormService.prototype.submitBooking = function submitBooking(
          request,
          callback
        ) {
          return this.rpcCall(
            submitBooking,
            $root.vhmformapi.bookvisit.SubmitBookingInput,
            $root.vhmformapi.bookvisit.SubmitBookingOutput,
            request,
            callback
          );
        }),
        "name",
        { value: "SubmitBooking" }
      );

      /**
       * Calls SubmitBooking.
       * @function submitBooking
       * @memberof vhmformapi.bookvisit.BookVisitFormService
       * @instance
       * @param {vhmformapi.bookvisit.ISubmitBookingInput} request SubmitBookingInput message or plain object
       * @returns {Promise<vhmformapi.bookvisit.SubmitBookingOutput>} Promise
       * @variation 2
       */

      return BookVisitFormService;
    })();

    return bookvisit;
  })();

  vhmformapi.cashRentCollection = (function () {
    /**
     * Namespace cashRentCollection.
     * @memberof vhmformapi
     * @namespace
     */
    const cashRentCollection = {};

    /**
     * ErrorCode enum.
     * @name vhmformapi.cashRentCollection.ErrorCode
     * @enum {number}
     * @property {number} CASH_RENT_COLLECTION_INVALID_SALESFORCE_API_RESPONSE=0 CASH_RENT_COLLECTION_INVALID_SALESFORCE_API_RESPONSE value
     * @property {number} CASH_RENT_COLLECTION_INVALID_ID=1 CASH_RENT_COLLECTION_INVALID_ID value
     * @property {number} CASH_RENT_COLLECTION_INTERNAL_ERROR=2 CASH_RENT_COLLECTION_INTERNAL_ERROR value
     * @property {number} CASH_RENT_COLLECTION_PUT_TEXT_INTO_S3_ERROR=3 CASH_RENT_COLLECTION_PUT_TEXT_INTO_S3_ERROR value
     * @property {number} CASH_RENT_COLLECTION_ENCRYPT_TEXT_ERROR=4 CASH_RENT_COLLECTION_ENCRYPT_TEXT_ERROR value
     * @property {number} CASH_RENT_COLLECTION_CONVERT_ERROR=5 CASH_RENT_COLLECTION_CONVERT_ERROR value
     * @property {number} CASH_RENT_COLLECTION_FORM_FIELD_VALIDATE_ERROR=6 CASH_RENT_COLLECTION_FORM_FIELD_VALIDATE_ERROR value
     * @property {number} CASH_RENT_COLLECTION_GET_ACCESS_TOKEN_ERROR=7 CASH_RENT_COLLECTION_GET_ACCESS_TOKEN_ERROR value
     * @property {number} CASH_RENT_COLLECTION_UNDEFINED_FORM_TYPE_ERROR=8 CASH_RENT_COLLECTION_UNDEFINED_FORM_TYPE_ERROR value
     * @property {number} CASH_RENT_COLLECTION_INVALID_IMAGES=9 CASH_RENT_COLLECTION_INVALID_IMAGES value
     * @property {number} CASH_RENT_COLLECTION_RECORD_ALREADY_EXISTED=10 CASH_RENT_COLLECTION_RECORD_ALREADY_EXISTED value
     * @property {number} CASH_RENT_COLLECTION_IMAGE_UPLOAD_FAILED=11 CASH_RENT_COLLECTION_IMAGE_UPLOAD_FAILED value
     */
    cashRentCollection.ErrorCode = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[
        (valuesById[0] = "CASH_RENT_COLLECTION_INVALID_SALESFORCE_API_RESPONSE")
      ] = 0;
      values[(valuesById[1] = "CASH_RENT_COLLECTION_INVALID_ID")] = 1;
      values[(valuesById[2] = "CASH_RENT_COLLECTION_INTERNAL_ERROR")] = 2;
      values[
        (valuesById[3] = "CASH_RENT_COLLECTION_PUT_TEXT_INTO_S3_ERROR")
      ] = 3;
      values[(valuesById[4] = "CASH_RENT_COLLECTION_ENCRYPT_TEXT_ERROR")] = 4;
      values[(valuesById[5] = "CASH_RENT_COLLECTION_CONVERT_ERROR")] = 5;
      values[
        (valuesById[6] = "CASH_RENT_COLLECTION_FORM_FIELD_VALIDATE_ERROR")
      ] = 6;
      values[
        (valuesById[7] = "CASH_RENT_COLLECTION_GET_ACCESS_TOKEN_ERROR")
      ] = 7;
      values[
        (valuesById[8] = "CASH_RENT_COLLECTION_UNDEFINED_FORM_TYPE_ERROR")
      ] = 8;
      values[(valuesById[9] = "CASH_RENT_COLLECTION_INVALID_IMAGES")] = 9;
      values[
        (valuesById[10] = "CASH_RENT_COLLECTION_RECORD_ALREADY_EXISTED")
      ] = 10;
      values[
        (valuesById[11] = "CASH_RENT_COLLECTION_IMAGE_UPLOAD_FAILED")
      ] = 11;
      return values;
    })();

    cashRentCollection.CashRentCollectionFormInput = (function () {
      /**
       * Properties of a CashRentCollectionFormInput.
       * @memberof vhmformapi.cashRentCollection
       * @interface ICashRentCollectionFormInput
       * @property {string|null} [billingManagementId] CashRentCollectionFormInput billingManagementId
       * @property {string|null} [propertyName] CashRentCollectionFormInput propertyName
       * @property {string|null} [customerName] CashRentCollectionFormInput customerName
       * @property {string|null} [cashRemittancePersonCaretaker3Id] CashRentCollectionFormInput cashRemittancePersonCaretaker3Id
       * @property {string|null} [expires] CashRentCollectionFormInput expires
       * @property {string|null} [language] CashRentCollectionFormInput language
       * @property {Array.<vhmformapi.cashRentCollection.CashRentCollectionFormInput.ISetupForm>|null} [values] CashRentCollectionFormInput values
       * @property {Array.<vhmformapi.cashRentCollection.CashRentCollectionFormInput.IImage>|null} [images] CashRentCollectionFormInput images
       */

      /**
       * Constructs a new CashRentCollectionFormInput.
       * @memberof vhmformapi.cashRentCollection
       * @classdesc Represents a CashRentCollectionFormInput.
       * @implements ICashRentCollectionFormInput
       * @constructor
       * @param {vhmformapi.cashRentCollection.ICashRentCollectionFormInput=} [properties] Properties to set
       */
      function CashRentCollectionFormInput(properties) {
        this.values = [];
        this.images = [];
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * CashRentCollectionFormInput billingManagementId.
       * @member {string} billingManagementId
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput
       * @instance
       */
      CashRentCollectionFormInput.prototype.billingManagementId = "";

      /**
       * CashRentCollectionFormInput propertyName.
       * @member {string} propertyName
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput
       * @instance
       */
      CashRentCollectionFormInput.prototype.propertyName = "";

      /**
       * CashRentCollectionFormInput customerName.
       * @member {string} customerName
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput
       * @instance
       */
      CashRentCollectionFormInput.prototype.customerName = "";

      /**
       * CashRentCollectionFormInput cashRemittancePersonCaretaker3Id.
       * @member {string} cashRemittancePersonCaretaker3Id
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput
       * @instance
       */
      CashRentCollectionFormInput.prototype.cashRemittancePersonCaretaker3Id =
        "";

      /**
       * CashRentCollectionFormInput expires.
       * @member {string} expires
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput
       * @instance
       */
      CashRentCollectionFormInput.prototype.expires = "";

      /**
       * CashRentCollectionFormInput language.
       * @member {string} language
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput
       * @instance
       */
      CashRentCollectionFormInput.prototype.language = "";

      /**
       * CashRentCollectionFormInput values.
       * @member {Array.<vhmformapi.cashRentCollection.CashRentCollectionFormInput.ISetupForm>} values
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput
       * @instance
       */
      CashRentCollectionFormInput.prototype.values = $util.emptyArray;

      /**
       * CashRentCollectionFormInput images.
       * @member {Array.<vhmformapi.cashRentCollection.CashRentCollectionFormInput.IImage>} images
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput
       * @instance
       */
      CashRentCollectionFormInput.prototype.images = $util.emptyArray;

      /**
       * Creates a new CashRentCollectionFormInput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput
       * @static
       * @param {vhmformapi.cashRentCollection.ICashRentCollectionFormInput=} [properties] Properties to set
       * @returns {vhmformapi.cashRentCollection.CashRentCollectionFormInput} CashRentCollectionFormInput instance
       */
      CashRentCollectionFormInput.create = function create(properties) {
        return new CashRentCollectionFormInput(properties);
      };

      /**
       * Encodes the specified CashRentCollectionFormInput message. Does not implicitly {@link vhmformapi.cashRentCollection.CashRentCollectionFormInput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput
       * @static
       * @param {vhmformapi.cashRentCollection.ICashRentCollectionFormInput} message CashRentCollectionFormInput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      CashRentCollectionFormInput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.billingManagementId != null &&
          Object.hasOwnProperty.call(message, "billingManagementId")
        )
          writer
            .uint32(/* id 1, wireType 2 =*/ 10)
            .string(message.billingManagementId);
        if (
          message.propertyName != null &&
          Object.hasOwnProperty.call(message, "propertyName")
        )
          writer
            .uint32(/* id 2, wireType 2 =*/ 18)
            .string(message.propertyName);
        if (
          message.customerName != null &&
          Object.hasOwnProperty.call(message, "customerName")
        )
          writer
            .uint32(/* id 3, wireType 2 =*/ 26)
            .string(message.customerName);
        if (
          message.cashRemittancePersonCaretaker3Id != null &&
          Object.hasOwnProperty.call(
            message,
            "cashRemittancePersonCaretaker3Id"
          )
        )
          writer
            .uint32(/* id 4, wireType 2 =*/ 34)
            .string(message.cashRemittancePersonCaretaker3Id);
        if (
          message.expires != null &&
          Object.hasOwnProperty.call(message, "expires")
        )
          writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.expires);
        if (
          message.language != null &&
          Object.hasOwnProperty.call(message, "language")
        )
          writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.language);
        if (message.values != null && message.values.length)
          for (let i = 0; i < message.values.length; ++i)
            $root.vhmformapi.cashRentCollection.CashRentCollectionFormInput.SetupForm.encode(
              message.values[i],
              writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
            ).ldelim();
        if (message.images != null && message.images.length)
          for (let i = 0; i < message.images.length; ++i)
            $root.vhmformapi.cashRentCollection.CashRentCollectionFormInput.Image.encode(
              message.images[i],
              writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
            ).ldelim();
        return writer;
      };

      /**
       * Decodes a CashRentCollectionFormInput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.cashRentCollection.CashRentCollectionFormInput} CashRentCollectionFormInput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      CashRentCollectionFormInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message =
            new $root.vhmformapi.cashRentCollection.CashRentCollectionFormInput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.billingManagementId = reader.string();
              break;
            }
            case 2: {
              message.propertyName = reader.string();
              break;
            }
            case 3: {
              message.customerName = reader.string();
              break;
            }
            case 4: {
              message.cashRemittancePersonCaretaker3Id = reader.string();
              break;
            }
            case 5: {
              message.expires = reader.string();
              break;
            }
            case 6: {
              message.language = reader.string();
              break;
            }
            case 7: {
              if (!(message.values && message.values.length))
                message.values = [];
              message.values.push(
                $root.vhmformapi.cashRentCollection.CashRentCollectionFormInput.SetupForm.decode(
                  reader,
                  reader.uint32()
                )
              );
              break;
            }
            case 8: {
              if (!(message.images && message.images.length))
                message.images = [];
              message.images.push(
                $root.vhmformapi.cashRentCollection.CashRentCollectionFormInput.Image.decode(
                  reader,
                  reader.uint32()
                )
              );
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      CashRentCollectionFormInput.SetupForm = (function () {
        /**
         * Properties of a SetupForm.
         * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput
         * @interface ISetupForm
         * @property {string|null} [name] SetupForm name
         * @property {Object.<string,string>|null} [value] SetupForm value
         */

        /**
         * Constructs a new SetupForm.
         * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput
         * @classdesc Represents a SetupForm.
         * @implements ISetupForm
         * @constructor
         * @param {vhmformapi.cashRentCollection.CashRentCollectionFormInput.ISetupForm=} [properties] Properties to set
         */
        function SetupForm(properties) {
          this.value = {};
          if (properties)
            for (
              let keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * SetupForm name.
         * @member {string} name
         * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput.SetupForm
         * @instance
         */
        SetupForm.prototype.name = "";

        /**
         * SetupForm value.
         * @member {Object.<string,string>} value
         * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput.SetupForm
         * @instance
         */
        SetupForm.prototype.value = $util.emptyObject;

        /**
         * Creates a new SetupForm instance using the specified properties.
         * @function create
         * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput.SetupForm
         * @static
         * @param {vhmformapi.cashRentCollection.CashRentCollectionFormInput.ISetupForm=} [properties] Properties to set
         * @returns {vhmformapi.cashRentCollection.CashRentCollectionFormInput.SetupForm} SetupForm instance
         */
        SetupForm.create = function create(properties) {
          return new SetupForm(properties);
        };

        /**
         * Encodes the specified SetupForm message. Does not implicitly {@link vhmformapi.cashRentCollection.CashRentCollectionFormInput.SetupForm.verify|verify} messages.
         * @function encode
         * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput.SetupForm
         * @static
         * @param {vhmformapi.cashRentCollection.CashRentCollectionFormInput.ISetupForm} message SetupForm message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetupForm.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.name != null &&
            Object.hasOwnProperty.call(message, "name")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (
            message.value != null &&
            Object.hasOwnProperty.call(message, "value")
          )
            for (
              let keys = Object.keys(message.value), i = 0;
              i < keys.length;
              ++i
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .fork()
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(keys[i])
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.value[keys[i]])
                .ldelim();
          return writer;
        };

        /**
         * Decodes a SetupForm message from the specified reader or buffer.
         * @function decode
         * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput.SetupForm
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {vhmformapi.cashRentCollection.CashRentCollectionFormInput.SetupForm} SetupForm
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetupForm.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length,
            message =
              new $root.vhmformapi.cashRentCollection.CashRentCollectionFormInput.SetupForm(),
            key,
            value;
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1: {
                message.name = reader.string();
                break;
              }
              case 2: {
                if (message.value === $util.emptyObject) message.value = {};
                let end2 = reader.uint32() + reader.pos;
                key = "";
                value = "";
                while (reader.pos < end2) {
                  let tag2 = reader.uint32();
                  switch (tag2 >>> 3) {
                    case 1:
                      key = reader.string();
                      break;
                    case 2:
                      value = reader.string();
                      break;
                    default:
                      reader.skipType(tag2 & 7);
                      break;
                  }
                }
                message.value[key] = value;
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        return SetupForm;
      })();

      CashRentCollectionFormInput.Image = (function () {
        /**
         * Properties of an Image.
         * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput
         * @interface IImage
         * @property {string|null} [name] Image name
         * @property {string|null} [type] Image type
         * @property {string|null} [position] Image position
         * @property {string|null} [data] Image data
         */

        /**
         * Constructs a new Image.
         * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput
         * @classdesc Represents an Image.
         * @implements IImage
         * @constructor
         * @param {vhmformapi.cashRentCollection.CashRentCollectionFormInput.IImage=} [properties] Properties to set
         */
        function Image(properties) {
          if (properties)
            for (
              let keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Image name.
         * @member {string} name
         * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput.Image
         * @instance
         */
        Image.prototype.name = "";

        /**
         * Image type.
         * @member {string} type
         * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput.Image
         * @instance
         */
        Image.prototype.type = "";

        /**
         * Image position.
         * @member {string} position
         * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput.Image
         * @instance
         */
        Image.prototype.position = "";

        /**
         * Image data.
         * @member {string} data
         * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput.Image
         * @instance
         */
        Image.prototype.data = "";

        /**
         * Creates a new Image instance using the specified properties.
         * @function create
         * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput.Image
         * @static
         * @param {vhmformapi.cashRentCollection.CashRentCollectionFormInput.IImage=} [properties] Properties to set
         * @returns {vhmformapi.cashRentCollection.CashRentCollectionFormInput.Image} Image instance
         */
        Image.create = function create(properties) {
          return new Image(properties);
        };

        /**
         * Encodes the specified Image message. Does not implicitly {@link vhmformapi.cashRentCollection.CashRentCollectionFormInput.Image.verify|verify} messages.
         * @function encode
         * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput.Image
         * @static
         * @param {vhmformapi.cashRentCollection.CashRentCollectionFormInput.IImage} message Image message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Image.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.name != null &&
            Object.hasOwnProperty.call(message, "name")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (
            message.type != null &&
            Object.hasOwnProperty.call(message, "type")
          )
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.type);
          if (
            message.position != null &&
            Object.hasOwnProperty.call(message, "position")
          )
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.position);
          if (
            message.data != null &&
            Object.hasOwnProperty.call(message, "data")
          )
            writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.data);
          return writer;
        };

        /**
         * Decodes an Image message from the specified reader or buffer.
         * @function decode
         * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormInput.Image
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {vhmformapi.cashRentCollection.CashRentCollectionFormInput.Image} Image
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Image.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length,
            message =
              new $root.vhmformapi.cashRentCollection.CashRentCollectionFormInput.Image();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1: {
                message.name = reader.string();
                break;
              }
              case 2: {
                message.type = reader.string();
                break;
              }
              case 3: {
                message.position = reader.string();
                break;
              }
              case 4: {
                message.data = reader.string();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        return Image;
      })();

      return CashRentCollectionFormInput;
    })();

    cashRentCollection.CashRentCollectionFormOutput = (function () {
      /**
       * Properties of a CashRentCollectionFormOutput.
       * @memberof vhmformapi.cashRentCollection
       * @interface ICashRentCollectionFormOutput
       * @property {string|null} [billingManagementId] CashRentCollectionFormOutput billingManagementId
       */

      /**
       * Constructs a new CashRentCollectionFormOutput.
       * @memberof vhmformapi.cashRentCollection
       * @classdesc Represents a CashRentCollectionFormOutput.
       * @implements ICashRentCollectionFormOutput
       * @constructor
       * @param {vhmformapi.cashRentCollection.ICashRentCollectionFormOutput=} [properties] Properties to set
       */
      function CashRentCollectionFormOutput(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * CashRentCollectionFormOutput billingManagementId.
       * @member {string} billingManagementId
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormOutput
       * @instance
       */
      CashRentCollectionFormOutput.prototype.billingManagementId = "";

      /**
       * Creates a new CashRentCollectionFormOutput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormOutput
       * @static
       * @param {vhmformapi.cashRentCollection.ICashRentCollectionFormOutput=} [properties] Properties to set
       * @returns {vhmformapi.cashRentCollection.CashRentCollectionFormOutput} CashRentCollectionFormOutput instance
       */
      CashRentCollectionFormOutput.create = function create(properties) {
        return new CashRentCollectionFormOutput(properties);
      };

      /**
       * Encodes the specified CashRentCollectionFormOutput message. Does not implicitly {@link vhmformapi.cashRentCollection.CashRentCollectionFormOutput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormOutput
       * @static
       * @param {vhmformapi.cashRentCollection.ICashRentCollectionFormOutput} message CashRentCollectionFormOutput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      CashRentCollectionFormOutput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.billingManagementId != null &&
          Object.hasOwnProperty.call(message, "billingManagementId")
        )
          writer
            .uint32(/* id 1, wireType 2 =*/ 10)
            .string(message.billingManagementId);
        return writer;
      };

      /**
       * Decodes a CashRentCollectionFormOutput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormOutput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.cashRentCollection.CashRentCollectionFormOutput} CashRentCollectionFormOutput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      CashRentCollectionFormOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message =
            new $root.vhmformapi.cashRentCollection.CashRentCollectionFormOutput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.billingManagementId = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      return CashRentCollectionFormOutput;
    })();

    cashRentCollection.CashRentCollectionFormService = (function () {
      /**
       * Constructs a new CashRentCollectionFormService service.
       * @memberof vhmformapi.cashRentCollection
       * @classdesc Represents a CashRentCollectionFormService
       * @extends $protobuf.rpc.Service
       * @constructor
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       */
      function CashRentCollectionFormService(
        rpcImpl,
        requestDelimited,
        responseDelimited
      ) {
        $protobuf.rpc.Service.call(
          this,
          rpcImpl,
          requestDelimited,
          responseDelimited
        );
      }

      (CashRentCollectionFormService.prototype = Object.create(
        $protobuf.rpc.Service.prototype
      )).constructor = CashRentCollectionFormService;

      /**
       * Creates new CashRentCollectionFormService service using the specified rpc implementation.
       * @function create
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormService
       * @static
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       * @returns {CashRentCollectionFormService} RPC service. Useful where requests and/or responses are streamed.
       */
      CashRentCollectionFormService.create = function create(
        rpcImpl,
        requestDelimited,
        responseDelimited
      ) {
        return new this(rpcImpl, requestDelimited, responseDelimited);
      };

      /**
       * Callback as used by {@link vhmformapi.cashRentCollection.CashRentCollectionFormService#submit}.
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormService
       * @typedef SubmitCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {vhmformapi.cashRentCollection.CashRentCollectionFormOutput} [response] CashRentCollectionFormOutput
       */

      /**
       * Calls Submit.
       * @function submit
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormService
       * @instance
       * @param {vhmformapi.cashRentCollection.ICashRentCollectionFormInput} request CashRentCollectionFormInput message or plain object
       * @param {vhmformapi.cashRentCollection.CashRentCollectionFormService.SubmitCallback} callback Node-style callback called with the error, if any, and CashRentCollectionFormOutput
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (CashRentCollectionFormService.prototype.submit = function submit(
          request,
          callback
        ) {
          return this.rpcCall(
            submit,
            $root.vhmformapi.cashRentCollection.CashRentCollectionFormInput,
            $root.vhmformapi.cashRentCollection.CashRentCollectionFormOutput,
            request,
            callback
          );
        }),
        "name",
        { value: "Submit" }
      );

      /**
       * Calls Submit.
       * @function submit
       * @memberof vhmformapi.cashRentCollection.CashRentCollectionFormService
       * @instance
       * @param {vhmformapi.cashRentCollection.ICashRentCollectionFormInput} request CashRentCollectionFormInput message or plain object
       * @returns {Promise<vhmformapi.cashRentCollection.CashRentCollectionFormOutput>} Promise
       * @variation 2
       */

      return CashRentCollectionFormService;
    })();

    return cashRentCollection;
  })();

  vhmformapi.enquiry = (function () {
    /**
     * Namespace enquiry.
     * @memberof vhmformapi
     * @namespace
     */
    const enquiry = {};

    /**
     * ErrorCode enum.
     * @name vhmformapi.enquiry.ErrorCode
     * @enum {number}
     * @property {number} CURRENT_URL_IS_EMPTY=0 CURRENT_URL_IS_EMPTY value
     * @property {number} INITIAL_ACCESS_URL_IS_EMPTY=1 INITIAL_ACCESS_URL_IS_EMPTY value
     * @property {number} PROPERTY_NOT_FOUND=2 PROPERTY_NOT_FOUND value
     * @property {number} ROOM_NOT_FOUND=3 ROOM_NOT_FOUND value
     * @property {number} RECORD_ID_IS_EMPTY=4 RECORD_ID_IS_EMPTY value
     * @property {number} CITY_NOT_FOUND=5 CITY_NOT_FOUND value
     * @property {number} CITY_IDS_IS_EMPTY=6 CITY_IDS_IS_EMPTY value
     */
    enquiry.ErrorCode = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = "CURRENT_URL_IS_EMPTY")] = 0;
      values[(valuesById[1] = "INITIAL_ACCESS_URL_IS_EMPTY")] = 1;
      values[(valuesById[2] = "PROPERTY_NOT_FOUND")] = 2;
      values[(valuesById[3] = "ROOM_NOT_FOUND")] = 3;
      values[(valuesById[4] = "RECORD_ID_IS_EMPTY")] = 4;
      values[(valuesById[5] = "CITY_NOT_FOUND")] = 5;
      values[(valuesById[6] = "CITY_IDS_IS_EMPTY")] = 6;
      return values;
    })();

    /**
     * PageType enum.
     * @name vhmformapi.enquiry.PageType
     * @enum {number}
     * @property {number} DEFAULT=0 DEFAULT value
     * @property {number} REFERRAL=1 REFERRAL value
     * @property {number} WAIT_LIST=2 WAIT_LIST value
     * @property {number} PARKING=3 PARKING value
     */
    enquiry.PageType = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = "DEFAULT")] = 0;
      values[(valuesById[1] = "REFERRAL")] = 1;
      values[(valuesById[2] = "WAIT_LIST")] = 2;
      values[(valuesById[3] = "PARKING")] = 3;
      return values;
    })();

    enquiry.SubmitEnquiryInput = (function () {
      /**
       * Properties of a SubmitEnquiryInput.
       * @memberof vhmformapi.enquiry
       * @interface ISubmitEnquiryInput
       * @property {vhmptypes.Language|null} [lang] SubmitEnquiryInput lang
       * @property {number|null} [propertyId] SubmitEnquiryInput propertyId
       * @property {string|null} [roomId] SubmitEnquiryInput roomId
       * @property {string|null} [name] SubmitEnquiryInput name
       * @property {string|null} [email] SubmitEnquiryInput email
       * @property {string|null} [telephone] SubmitEnquiryInput telephone
       * @property {string|null} [message] SubmitEnquiryInput message
       * @property {string|null} [currentUrl] SubmitEnquiryInput currentUrl
       * @property {string|null} [initialAccessUrl] SubmitEnquiryInput initialAccessUrl
       * @property {vhmformapi.enquiry.PageType|null} [pageType] SubmitEnquiryInput pageType
       * @property {string|null} [recordId] SubmitEnquiryInput recordId
       * @property {string|null} [testGroup] SubmitEnquiryInput testGroup
       */

      /**
       * Constructs a new SubmitEnquiryInput.
       * @memberof vhmformapi.enquiry
       * @classdesc Represents a SubmitEnquiryInput.
       * @implements ISubmitEnquiryInput
       * @constructor
       * @param {vhmformapi.enquiry.ISubmitEnquiryInput=} [properties] Properties to set
       */
      function SubmitEnquiryInput(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * SubmitEnquiryInput lang.
       * @member {vhmptypes.Language} lang
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @instance
       */
      SubmitEnquiryInput.prototype.lang = 0;

      /**
       * SubmitEnquiryInput propertyId.
       * @member {number|null|undefined} propertyId
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @instance
       */
      SubmitEnquiryInput.prototype.propertyId = null;

      /**
       * SubmitEnquiryInput roomId.
       * @member {string|null|undefined} roomId
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @instance
       */
      SubmitEnquiryInput.prototype.roomId = null;

      /**
       * SubmitEnquiryInput name.
       * @member {string} name
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @instance
       */
      SubmitEnquiryInput.prototype.name = "";

      /**
       * SubmitEnquiryInput email.
       * @member {string} email
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @instance
       */
      SubmitEnquiryInput.prototype.email = "";

      /**
       * SubmitEnquiryInput telephone.
       * @member {string} telephone
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @instance
       */
      SubmitEnquiryInput.prototype.telephone = "";

      /**
       * SubmitEnquiryInput message.
       * @member {string} message
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @instance
       */
      SubmitEnquiryInput.prototype.message = "";

      /**
       * SubmitEnquiryInput currentUrl.
       * @member {string} currentUrl
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @instance
       */
      SubmitEnquiryInput.prototype.currentUrl = "";

      /**
       * SubmitEnquiryInput initialAccessUrl.
       * @member {string} initialAccessUrl
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @instance
       */
      SubmitEnquiryInput.prototype.initialAccessUrl = "";

      /**
       * SubmitEnquiryInput pageType.
       * @member {vhmformapi.enquiry.PageType} pageType
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @instance
       */
      SubmitEnquiryInput.prototype.pageType = 0;

      /**
       * SubmitEnquiryInput recordId.
       * @member {string} recordId
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @instance
       */
      SubmitEnquiryInput.prototype.recordId = "";

      /**
       * SubmitEnquiryInput testGroup.
       * @member {string} testGroup
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @instance
       */
      SubmitEnquiryInput.prototype.testGroup = "";

      // OneOf field names bound to virtual getters and setters
      let $oneOfFields;

      /**
       * SubmitEnquiryInput _propertyId.
       * @member {"propertyId"|undefined} _propertyId
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @instance
       */
      Object.defineProperty(SubmitEnquiryInput.prototype, "_propertyId", {
        get: $util.oneOfGetter(($oneOfFields = ["propertyId"])),
        set: $util.oneOfSetter($oneOfFields),
      });

      /**
       * SubmitEnquiryInput _roomId.
       * @member {"roomId"|undefined} _roomId
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @instance
       */
      Object.defineProperty(SubmitEnquiryInput.prototype, "_roomId", {
        get: $util.oneOfGetter(($oneOfFields = ["roomId"])),
        set: $util.oneOfSetter($oneOfFields),
      });

      /**
       * Creates a new SubmitEnquiryInput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @static
       * @param {vhmformapi.enquiry.ISubmitEnquiryInput=} [properties] Properties to set
       * @returns {vhmformapi.enquiry.SubmitEnquiryInput} SubmitEnquiryInput instance
       */
      SubmitEnquiryInput.create = function create(properties) {
        return new SubmitEnquiryInput(properties);
      };

      /**
       * Encodes the specified SubmitEnquiryInput message. Does not implicitly {@link vhmformapi.enquiry.SubmitEnquiryInput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @static
       * @param {vhmformapi.enquiry.ISubmitEnquiryInput} message SubmitEnquiryInput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      SubmitEnquiryInput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.lang != null && Object.hasOwnProperty.call(message, "lang"))
          writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.lang);
        if (
          message.propertyId != null &&
          Object.hasOwnProperty.call(message, "propertyId")
        )
          writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.propertyId);
        if (
          message.roomId != null &&
          Object.hasOwnProperty.call(message, "roomId")
        )
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.roomId);
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
          writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.name);
        if (
          message.email != null &&
          Object.hasOwnProperty.call(message, "email")
        )
          writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.email);
        if (
          message.telephone != null &&
          Object.hasOwnProperty.call(message, "telephone")
        )
          writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.telephone);
        if (
          message.message != null &&
          Object.hasOwnProperty.call(message, "message")
        )
          writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.message);
        if (
          message.currentUrl != null &&
          Object.hasOwnProperty.call(message, "currentUrl")
        )
          writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.currentUrl);
        if (
          message.initialAccessUrl != null &&
          Object.hasOwnProperty.call(message, "initialAccessUrl")
        )
          writer
            .uint32(/* id 9, wireType 2 =*/ 74)
            .string(message.initialAccessUrl);
        if (
          message.pageType != null &&
          Object.hasOwnProperty.call(message, "pageType")
        )
          writer.uint32(/* id 10, wireType 0 =*/ 80).int32(message.pageType);
        if (
          message.recordId != null &&
          Object.hasOwnProperty.call(message, "recordId")
        )
          writer.uint32(/* id 11, wireType 2 =*/ 90).string(message.recordId);
        if (
          message.testGroup != null &&
          Object.hasOwnProperty.call(message, "testGroup")
        )
          writer.uint32(/* id 12, wireType 2 =*/ 98).string(message.testGroup);
        return writer;
      };

      /**
       * Decodes a SubmitEnquiryInput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.enquiry.SubmitEnquiryInput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.enquiry.SubmitEnquiryInput} SubmitEnquiryInput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      SubmitEnquiryInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.vhmformapi.enquiry.SubmitEnquiryInput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.lang = reader.int32();
              break;
            }
            case 2: {
              message.propertyId = reader.int32();
              break;
            }
            case 3: {
              message.roomId = reader.string();
              break;
            }
            case 4: {
              message.name = reader.string();
              break;
            }
            case 5: {
              message.email = reader.string();
              break;
            }
            case 6: {
              message.telephone = reader.string();
              break;
            }
            case 7: {
              message.message = reader.string();
              break;
            }
            case 8: {
              message.currentUrl = reader.string();
              break;
            }
            case 9: {
              message.initialAccessUrl = reader.string();
              break;
            }
            case 10: {
              message.pageType = reader.int32();
              break;
            }
            case 11: {
              message.recordId = reader.string();
              break;
            }
            case 12: {
              message.testGroup = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      return SubmitEnquiryInput;
    })();

    enquiry.SubmitCorporateEnquiryInput = (function () {
      /**
       * Properties of a SubmitCorporateEnquiryInput.
       * @memberof vhmformapi.enquiry
       * @interface ISubmitCorporateEnquiryInput
       * @property {vhmptypes.Language|null} [lang] SubmitCorporateEnquiryInput lang
       * @property {number|null} [propertyId] SubmitCorporateEnquiryInput propertyId
       * @property {string|null} [roomId] SubmitCorporateEnquiryInput roomId
       * @property {Array.<string>|null} [cityIds] SubmitCorporateEnquiryInput cityIds
       * @property {string|null} [corporateName] SubmitCorporateEnquiryInput corporateName
       * @property {string|null} [representative] SubmitCorporateEnquiryInput representative
       * @property {string|null} [email] SubmitCorporateEnquiryInput email
       * @property {string|null} [telephone] SubmitCorporateEnquiryInput telephone
       * @property {number|null} [residentCount] SubmitCorporateEnquiryInput residentCount
       * @property {string|null} [perCapitaBudget] SubmitCorporateEnquiryInput perCapitaBudget
       * @property {string|null} [message] SubmitCorporateEnquiryInput message
       * @property {string|null} [currentUrl] SubmitCorporateEnquiryInput currentUrl
       * @property {string|null} [initialAccessUrl] SubmitCorporateEnquiryInput initialAccessUrl
       * @property {vhmformapi.enquiry.PageType|null} [pageType] SubmitCorporateEnquiryInput pageType
       * @property {string|null} [recordId] SubmitCorporateEnquiryInput recordId
       */

      /**
       * Constructs a new SubmitCorporateEnquiryInput.
       * @memberof vhmformapi.enquiry
       * @classdesc Represents a SubmitCorporateEnquiryInput.
       * @implements ISubmitCorporateEnquiryInput
       * @constructor
       * @param {vhmformapi.enquiry.ISubmitCorporateEnquiryInput=} [properties] Properties to set
       */
      function SubmitCorporateEnquiryInput(properties) {
        this.cityIds = [];
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * SubmitCorporateEnquiryInput lang.
       * @member {vhmptypes.Language} lang
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      SubmitCorporateEnquiryInput.prototype.lang = 0;

      /**
       * SubmitCorporateEnquiryInput propertyId.
       * @member {number|null|undefined} propertyId
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      SubmitCorporateEnquiryInput.prototype.propertyId = null;

      /**
       * SubmitCorporateEnquiryInput roomId.
       * @member {string|null|undefined} roomId
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      SubmitCorporateEnquiryInput.prototype.roomId = null;

      /**
       * SubmitCorporateEnquiryInput cityIds.
       * @member {Array.<string>} cityIds
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      SubmitCorporateEnquiryInput.prototype.cityIds = $util.emptyArray;

      /**
       * SubmitCorporateEnquiryInput corporateName.
       * @member {string} corporateName
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      SubmitCorporateEnquiryInput.prototype.corporateName = "";

      /**
       * SubmitCorporateEnquiryInput representative.
       * @member {string} representative
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      SubmitCorporateEnquiryInput.prototype.representative = "";

      /**
       * SubmitCorporateEnquiryInput email.
       * @member {string} email
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      SubmitCorporateEnquiryInput.prototype.email = "";

      /**
       * SubmitCorporateEnquiryInput telephone.
       * @member {string} telephone
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      SubmitCorporateEnquiryInput.prototype.telephone = "";

      /**
       * SubmitCorporateEnquiryInput residentCount.
       * @member {number|null|undefined} residentCount
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      SubmitCorporateEnquiryInput.prototype.residentCount = null;

      /**
       * SubmitCorporateEnquiryInput perCapitaBudget.
       * @member {string|null|undefined} perCapitaBudget
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      SubmitCorporateEnquiryInput.prototype.perCapitaBudget = null;

      /**
       * SubmitCorporateEnquiryInput message.
       * @member {string} message
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      SubmitCorporateEnquiryInput.prototype.message = "";

      /**
       * SubmitCorporateEnquiryInput currentUrl.
       * @member {string} currentUrl
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      SubmitCorporateEnquiryInput.prototype.currentUrl = "";

      /**
       * SubmitCorporateEnquiryInput initialAccessUrl.
       * @member {string} initialAccessUrl
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      SubmitCorporateEnquiryInput.prototype.initialAccessUrl = "";

      /**
       * SubmitCorporateEnquiryInput pageType.
       * @member {vhmformapi.enquiry.PageType} pageType
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      SubmitCorporateEnquiryInput.prototype.pageType = 0;

      /**
       * SubmitCorporateEnquiryInput recordId.
       * @member {string} recordId
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      SubmitCorporateEnquiryInput.prototype.recordId = "";

      // OneOf field names bound to virtual getters and setters
      let $oneOfFields;

      /**
       * SubmitCorporateEnquiryInput _propertyId.
       * @member {"propertyId"|undefined} _propertyId
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      Object.defineProperty(
        SubmitCorporateEnquiryInput.prototype,
        "_propertyId",
        {
          get: $util.oneOfGetter(($oneOfFields = ["propertyId"])),
          set: $util.oneOfSetter($oneOfFields),
        }
      );

      /**
       * SubmitCorporateEnquiryInput _roomId.
       * @member {"roomId"|undefined} _roomId
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      Object.defineProperty(SubmitCorporateEnquiryInput.prototype, "_roomId", {
        get: $util.oneOfGetter(($oneOfFields = ["roomId"])),
        set: $util.oneOfSetter($oneOfFields),
      });

      /**
       * SubmitCorporateEnquiryInput _residentCount.
       * @member {"residentCount"|undefined} _residentCount
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      Object.defineProperty(
        SubmitCorporateEnquiryInput.prototype,
        "_residentCount",
        {
          get: $util.oneOfGetter(($oneOfFields = ["residentCount"])),
          set: $util.oneOfSetter($oneOfFields),
        }
      );

      /**
       * SubmitCorporateEnquiryInput _perCapitaBudget.
       * @member {"perCapitaBudget"|undefined} _perCapitaBudget
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @instance
       */
      Object.defineProperty(
        SubmitCorporateEnquiryInput.prototype,
        "_perCapitaBudget",
        {
          get: $util.oneOfGetter(($oneOfFields = ["perCapitaBudget"])),
          set: $util.oneOfSetter($oneOfFields),
        }
      );

      /**
       * Creates a new SubmitCorporateEnquiryInput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @static
       * @param {vhmformapi.enquiry.ISubmitCorporateEnquiryInput=} [properties] Properties to set
       * @returns {vhmformapi.enquiry.SubmitCorporateEnquiryInput} SubmitCorporateEnquiryInput instance
       */
      SubmitCorporateEnquiryInput.create = function create(properties) {
        return new SubmitCorporateEnquiryInput(properties);
      };

      /**
       * Encodes the specified SubmitCorporateEnquiryInput message. Does not implicitly {@link vhmformapi.enquiry.SubmitCorporateEnquiryInput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @static
       * @param {vhmformapi.enquiry.ISubmitCorporateEnquiryInput} message SubmitCorporateEnquiryInput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      SubmitCorporateEnquiryInput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (message.lang != null && Object.hasOwnProperty.call(message, "lang"))
          writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.lang);
        if (
          message.propertyId != null &&
          Object.hasOwnProperty.call(message, "propertyId")
        )
          writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.propertyId);
        if (
          message.roomId != null &&
          Object.hasOwnProperty.call(message, "roomId")
        )
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.roomId);
        if (message.cityIds != null && message.cityIds.length)
          for (let i = 0; i < message.cityIds.length; ++i)
            writer
              .uint32(/* id 4, wireType 2 =*/ 34)
              .string(message.cityIds[i]);
        if (
          message.corporateName != null &&
          Object.hasOwnProperty.call(message, "corporateName")
        )
          writer
            .uint32(/* id 5, wireType 2 =*/ 42)
            .string(message.corporateName);
        if (
          message.representative != null &&
          Object.hasOwnProperty.call(message, "representative")
        )
          writer
            .uint32(/* id 6, wireType 2 =*/ 50)
            .string(message.representative);
        if (
          message.email != null &&
          Object.hasOwnProperty.call(message, "email")
        )
          writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.email);
        if (
          message.telephone != null &&
          Object.hasOwnProperty.call(message, "telephone")
        )
          writer.uint32(/* id 8, wireType 2 =*/ 66).string(message.telephone);
        if (
          message.residentCount != null &&
          Object.hasOwnProperty.call(message, "residentCount")
        )
          writer
            .uint32(/* id 9, wireType 0 =*/ 72)
            .int32(message.residentCount);
        if (
          message.perCapitaBudget != null &&
          Object.hasOwnProperty.call(message, "perCapitaBudget")
        )
          writer
            .uint32(/* id 10, wireType 2 =*/ 82)
            .string(message.perCapitaBudget);
        if (
          message.message != null &&
          Object.hasOwnProperty.call(message, "message")
        )
          writer.uint32(/* id 11, wireType 2 =*/ 90).string(message.message);
        if (
          message.currentUrl != null &&
          Object.hasOwnProperty.call(message, "currentUrl")
        )
          writer.uint32(/* id 12, wireType 2 =*/ 98).string(message.currentUrl);
        if (
          message.initialAccessUrl != null &&
          Object.hasOwnProperty.call(message, "initialAccessUrl")
        )
          writer
            .uint32(/* id 13, wireType 2 =*/ 106)
            .string(message.initialAccessUrl);
        if (
          message.pageType != null &&
          Object.hasOwnProperty.call(message, "pageType")
        )
          writer.uint32(/* id 14, wireType 0 =*/ 112).int32(message.pageType);
        if (
          message.recordId != null &&
          Object.hasOwnProperty.call(message, "recordId")
        )
          writer.uint32(/* id 15, wireType 2 =*/ 122).string(message.recordId);
        return writer;
      };

      /**
       * Decodes a SubmitCorporateEnquiryInput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.enquiry.SubmitCorporateEnquiryInput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.enquiry.SubmitCorporateEnquiryInput} SubmitCorporateEnquiryInput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      SubmitCorporateEnquiryInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.vhmformapi.enquiry.SubmitCorporateEnquiryInput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.lang = reader.int32();
              break;
            }
            case 2: {
              message.propertyId = reader.int32();
              break;
            }
            case 3: {
              message.roomId = reader.string();
              break;
            }
            case 4: {
              if (!(message.cityIds && message.cityIds.length))
                message.cityIds = [];
              message.cityIds.push(reader.string());
              break;
            }
            case 5: {
              message.corporateName = reader.string();
              break;
            }
            case 6: {
              message.representative = reader.string();
              break;
            }
            case 7: {
              message.email = reader.string();
              break;
            }
            case 8: {
              message.telephone = reader.string();
              break;
            }
            case 9: {
              message.residentCount = reader.int32();
              break;
            }
            case 10: {
              message.perCapitaBudget = reader.string();
              break;
            }
            case 11: {
              message.message = reader.string();
              break;
            }
            case 12: {
              message.currentUrl = reader.string();
              break;
            }
            case 13: {
              message.initialAccessUrl = reader.string();
              break;
            }
            case 14: {
              message.pageType = reader.int32();
              break;
            }
            case 15: {
              message.recordId = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      return SubmitCorporateEnquiryInput;
    })();

    enquiry.SubmitEnquiryOutput = (function () {
      /**
       * Properties of a SubmitEnquiryOutput.
       * @memberof vhmformapi.enquiry
       * @interface ISubmitEnquiryOutput
       * @property {string|null} [redirectUrl] SubmitEnquiryOutput redirectUrl
       * @property {string|null} [recordId] SubmitEnquiryOutput recordId
       */

      /**
       * Constructs a new SubmitEnquiryOutput.
       * @memberof vhmformapi.enquiry
       * @classdesc Represents a SubmitEnquiryOutput.
       * @implements ISubmitEnquiryOutput
       * @constructor
       * @param {vhmformapi.enquiry.ISubmitEnquiryOutput=} [properties] Properties to set
       */
      function SubmitEnquiryOutput(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * SubmitEnquiryOutput redirectUrl.
       * @member {string} redirectUrl
       * @memberof vhmformapi.enquiry.SubmitEnquiryOutput
       * @instance
       */
      SubmitEnquiryOutput.prototype.redirectUrl = "";

      /**
       * SubmitEnquiryOutput recordId.
       * @member {string} recordId
       * @memberof vhmformapi.enquiry.SubmitEnquiryOutput
       * @instance
       */
      SubmitEnquiryOutput.prototype.recordId = "";

      /**
       * Creates a new SubmitEnquiryOutput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.enquiry.SubmitEnquiryOutput
       * @static
       * @param {vhmformapi.enquiry.ISubmitEnquiryOutput=} [properties] Properties to set
       * @returns {vhmformapi.enquiry.SubmitEnquiryOutput} SubmitEnquiryOutput instance
       */
      SubmitEnquiryOutput.create = function create(properties) {
        return new SubmitEnquiryOutput(properties);
      };

      /**
       * Encodes the specified SubmitEnquiryOutput message. Does not implicitly {@link vhmformapi.enquiry.SubmitEnquiryOutput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.enquiry.SubmitEnquiryOutput
       * @static
       * @param {vhmformapi.enquiry.ISubmitEnquiryOutput} message SubmitEnquiryOutput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      SubmitEnquiryOutput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.redirectUrl != null &&
          Object.hasOwnProperty.call(message, "redirectUrl")
        )
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.redirectUrl);
        if (
          message.recordId != null &&
          Object.hasOwnProperty.call(message, "recordId")
        )
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.recordId);
        return writer;
      };

      /**
       * Decodes a SubmitEnquiryOutput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.enquiry.SubmitEnquiryOutput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.enquiry.SubmitEnquiryOutput} SubmitEnquiryOutput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      SubmitEnquiryOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.vhmformapi.enquiry.SubmitEnquiryOutput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.redirectUrl = reader.string();
              break;
            }
            case 2: {
              message.recordId = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      return SubmitEnquiryOutput;
    })();

    enquiry.EnquiryFormService = (function () {
      /**
       * Constructs a new EnquiryFormService service.
       * @memberof vhmformapi.enquiry
       * @classdesc Represents an EnquiryFormService
       * @extends $protobuf.rpc.Service
       * @constructor
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       */
      function EnquiryFormService(
        rpcImpl,
        requestDelimited,
        responseDelimited
      ) {
        $protobuf.rpc.Service.call(
          this,
          rpcImpl,
          requestDelimited,
          responseDelimited
        );
      }

      (EnquiryFormService.prototype = Object.create(
        $protobuf.rpc.Service.prototype
      )).constructor = EnquiryFormService;

      /**
       * Creates new EnquiryFormService service using the specified rpc implementation.
       * @function create
       * @memberof vhmformapi.enquiry.EnquiryFormService
       * @static
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       * @returns {EnquiryFormService} RPC service. Useful where requests and/or responses are streamed.
       */
      EnquiryFormService.create = function create(
        rpcImpl,
        requestDelimited,
        responseDelimited
      ) {
        return new this(rpcImpl, requestDelimited, responseDelimited);
      };

      /**
       * Callback as used by {@link vhmformapi.enquiry.EnquiryFormService#submitEnquiry}.
       * @memberof vhmformapi.enquiry.EnquiryFormService
       * @typedef SubmitEnquiryCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {vhmformapi.enquiry.SubmitEnquiryOutput} [response] SubmitEnquiryOutput
       */

      /**
       * Calls SubmitEnquiry.
       * @function submitEnquiry
       * @memberof vhmformapi.enquiry.EnquiryFormService
       * @instance
       * @param {vhmformapi.enquiry.ISubmitEnquiryInput} request SubmitEnquiryInput message or plain object
       * @param {vhmformapi.enquiry.EnquiryFormService.SubmitEnquiryCallback} callback Node-style callback called with the error, if any, and SubmitEnquiryOutput
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (EnquiryFormService.prototype.submitEnquiry = function submitEnquiry(
          request,
          callback
        ) {
          return this.rpcCall(
            submitEnquiry,
            $root.vhmformapi.enquiry.SubmitEnquiryInput,
            $root.vhmformapi.enquiry.SubmitEnquiryOutput,
            request,
            callback
          );
        }),
        "name",
        { value: "SubmitEnquiry" }
      );

      /**
       * Calls SubmitEnquiry.
       * @function submitEnquiry
       * @memberof vhmformapi.enquiry.EnquiryFormService
       * @instance
       * @param {vhmformapi.enquiry.ISubmitEnquiryInput} request SubmitEnquiryInput message or plain object
       * @returns {Promise<vhmformapi.enquiry.SubmitEnquiryOutput>} Promise
       * @variation 2
       */

      /**
       * Callback as used by {@link vhmformapi.enquiry.EnquiryFormService#submitCorporateEnquiry}.
       * @memberof vhmformapi.enquiry.EnquiryFormService
       * @typedef SubmitCorporateEnquiryCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {vhmformapi.enquiry.SubmitEnquiryOutput} [response] SubmitEnquiryOutput
       */

      /**
       * Calls SubmitCorporateEnquiry.
       * @function submitCorporateEnquiry
       * @memberof vhmformapi.enquiry.EnquiryFormService
       * @instance
       * @param {vhmformapi.enquiry.ISubmitCorporateEnquiryInput} request SubmitCorporateEnquiryInput message or plain object
       * @param {vhmformapi.enquiry.EnquiryFormService.SubmitCorporateEnquiryCallback} callback Node-style callback called with the error, if any, and SubmitEnquiryOutput
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (EnquiryFormService.prototype.submitCorporateEnquiry =
          function submitCorporateEnquiry(request, callback) {
            return this.rpcCall(
              submitCorporateEnquiry,
              $root.vhmformapi.enquiry.SubmitCorporateEnquiryInput,
              $root.vhmformapi.enquiry.SubmitEnquiryOutput,
              request,
              callback
            );
          }),
        "name",
        { value: "SubmitCorporateEnquiry" }
      );

      /**
       * Calls SubmitCorporateEnquiry.
       * @function submitCorporateEnquiry
       * @memberof vhmformapi.enquiry.EnquiryFormService
       * @instance
       * @param {vhmformapi.enquiry.ISubmitCorporateEnquiryInput} request SubmitCorporateEnquiryInput message or plain object
       * @returns {Promise<vhmformapi.enquiry.SubmitEnquiryOutput>} Promise
       * @variation 2
       */

      return EnquiryFormService;
    })();

    return enquiry;
  })();

  vhmformapi.onlineCancel = (function () {
    /**
     * Namespace onlineCancel.
     * @memberof vhmformapi
     * @namespace
     */
    const onlineCancel = {};

    /**
     * ErrorCode enum.
     * @name vhmformapi.onlineCancel.ErrorCode
     * @enum {number}
     * @property {number} ONLINE_CANCEL_INVALID_SALESFORCE_API_RESPONSE=0 ONLINE_CANCEL_INVALID_SALESFORCE_API_RESPONSE value
     * @property {number} ONLINE_CANCEL_INVALID_ID=1 ONLINE_CANCEL_INVALID_ID value
     * @property {number} ONLINE_CANCEL_INTERNAL_ERROR=2 ONLINE_CANCEL_INTERNAL_ERROR value
     * @property {number} ONLINE_CANCEL_PUT_TEXT_INTO_S3_ERROR=3 ONLINE_CANCEL_PUT_TEXT_INTO_S3_ERROR value
     * @property {number} ONLINE_CANCEL_ENCRYPT_TEXT_ERROR=4 ONLINE_CANCEL_ENCRYPT_TEXT_ERROR value
     * @property {number} ONLINE_CANCEL_CONVERT_ERROR=5 ONLINE_CANCEL_CONVERT_ERROR value
     * @property {number} ONLINE_CANCEL_FORM_FIELD_VALIDATE_ERROR=6 ONLINE_CANCEL_FORM_FIELD_VALIDATE_ERROR value
     * @property {number} ONLINE_CANCEL_GET_ACCESS_TOKEN_ERROR=7 ONLINE_CANCEL_GET_ACCESS_TOKEN_ERROR value
     * @property {number} ONLINE_CANCEL_UNDEFINED_FORM_TYPE_ERROR=8 ONLINE_CANCEL_UNDEFINED_FORM_TYPE_ERROR value
     */
    onlineCancel.ErrorCode = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[
        (valuesById[0] = "ONLINE_CANCEL_INVALID_SALESFORCE_API_RESPONSE")
      ] = 0;
      values[(valuesById[1] = "ONLINE_CANCEL_INVALID_ID")] = 1;
      values[(valuesById[2] = "ONLINE_CANCEL_INTERNAL_ERROR")] = 2;
      values[(valuesById[3] = "ONLINE_CANCEL_PUT_TEXT_INTO_S3_ERROR")] = 3;
      values[(valuesById[4] = "ONLINE_CANCEL_ENCRYPT_TEXT_ERROR")] = 4;
      values[(valuesById[5] = "ONLINE_CANCEL_CONVERT_ERROR")] = 5;
      values[(valuesById[6] = "ONLINE_CANCEL_FORM_FIELD_VALIDATE_ERROR")] = 6;
      values[(valuesById[7] = "ONLINE_CANCEL_GET_ACCESS_TOKEN_ERROR")] = 7;
      values[(valuesById[8] = "ONLINE_CANCEL_UNDEFINED_FORM_TYPE_ERROR")] = 8;
      return values;
    })();

    onlineCancel.CancellationFormInput = (function () {
      /**
       * Properties of a CancellationFormInput.
       * @memberof vhmformapi.onlineCancel
       * @interface ICancellationFormInput
       * @property {string|null} [accountId] CancellationFormInput accountId
       * @property {string|null} [language] CancellationFormInput language
       * @property {string|null} [noticePeriod] CancellationFormInput noticePeriod
       * @property {string|null} [paymentMethod] CancellationFormInput paymentMethod
       * @property {Array.<vhmformapi.onlineCancel.CancellationFormInput.ISetupForm>|null} [values] CancellationFormInput values
       * @property {string|null} [formType] CancellationFormInput formType
       * @property {string|null} [bukkakuCode] CancellationFormInput bukkakuCode
       * @property {string|null} [parkingName01] CancellationFormInput parkingName01
       * @property {string|null} [parkingName02] CancellationFormInput parkingName02
       * @property {string|null} [parkingName03] CancellationFormInput parkingName03
       * @property {string|null} [contractId] CancellationFormInput contractId
       * @property {string|null} [parkingContractId01] CancellationFormInput parkingContractId01
       * @property {string|null} [parkingContractId02] CancellationFormInput parkingContractId02
       * @property {string|null} [parkingContractId03] CancellationFormInput parkingContractId03
       * @property {string|null} [sendDate] CancellationFormInput sendDate
       */

      /**
       * Constructs a new CancellationFormInput.
       * @memberof vhmformapi.onlineCancel
       * @classdesc Represents a CancellationFormInput.
       * @implements ICancellationFormInput
       * @constructor
       * @param {vhmformapi.onlineCancel.ICancellationFormInput=} [properties] Properties to set
       */
      function CancellationFormInput(properties) {
        this.values = [];
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * CancellationFormInput accountId.
       * @member {string} accountId
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @instance
       */
      CancellationFormInput.prototype.accountId = "";

      /**
       * CancellationFormInput language.
       * @member {string} language
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @instance
       */
      CancellationFormInput.prototype.language = "";

      /**
       * CancellationFormInput noticePeriod.
       * @member {string} noticePeriod
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @instance
       */
      CancellationFormInput.prototype.noticePeriod = "";

      /**
       * CancellationFormInput paymentMethod.
       * @member {string} paymentMethod
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @instance
       */
      CancellationFormInput.prototype.paymentMethod = "";

      /**
       * CancellationFormInput values.
       * @member {Array.<vhmformapi.onlineCancel.CancellationFormInput.ISetupForm>} values
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @instance
       */
      CancellationFormInput.prototype.values = $util.emptyArray;

      /**
       * CancellationFormInput formType.
       * @member {string} formType
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @instance
       */
      CancellationFormInput.prototype.formType = "";

      /**
       * CancellationFormInput bukkakuCode.
       * @member {string} bukkakuCode
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @instance
       */
      CancellationFormInput.prototype.bukkakuCode = "";

      /**
       * CancellationFormInput parkingName01.
       * @member {string} parkingName01
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @instance
       */
      CancellationFormInput.prototype.parkingName01 = "";

      /**
       * CancellationFormInput parkingName02.
       * @member {string} parkingName02
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @instance
       */
      CancellationFormInput.prototype.parkingName02 = "";

      /**
       * CancellationFormInput parkingName03.
       * @member {string} parkingName03
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @instance
       */
      CancellationFormInput.prototype.parkingName03 = "";

      /**
       * CancellationFormInput contractId.
       * @member {string} contractId
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @instance
       */
      CancellationFormInput.prototype.contractId = "";

      /**
       * CancellationFormInput parkingContractId01.
       * @member {string} parkingContractId01
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @instance
       */
      CancellationFormInput.prototype.parkingContractId01 = "";

      /**
       * CancellationFormInput parkingContractId02.
       * @member {string} parkingContractId02
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @instance
       */
      CancellationFormInput.prototype.parkingContractId02 = "";

      /**
       * CancellationFormInput parkingContractId03.
       * @member {string} parkingContractId03
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @instance
       */
      CancellationFormInput.prototype.parkingContractId03 = "";

      /**
       * CancellationFormInput sendDate.
       * @member {string} sendDate
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @instance
       */
      CancellationFormInput.prototype.sendDate = "";

      /**
       * Creates a new CancellationFormInput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @static
       * @param {vhmformapi.onlineCancel.ICancellationFormInput=} [properties] Properties to set
       * @returns {vhmformapi.onlineCancel.CancellationFormInput} CancellationFormInput instance
       */
      CancellationFormInput.create = function create(properties) {
        return new CancellationFormInput(properties);
      };

      /**
       * Encodes the specified CancellationFormInput message. Does not implicitly {@link vhmformapi.onlineCancel.CancellationFormInput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @static
       * @param {vhmformapi.onlineCancel.ICancellationFormInput} message CancellationFormInput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      CancellationFormInput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.accountId != null &&
          Object.hasOwnProperty.call(message, "accountId")
        )
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.accountId);
        if (
          message.language != null &&
          Object.hasOwnProperty.call(message, "language")
        )
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.language);
        if (
          message.noticePeriod != null &&
          Object.hasOwnProperty.call(message, "noticePeriod")
        )
          writer
            .uint32(/* id 3, wireType 2 =*/ 26)
            .string(message.noticePeriod);
        if (
          message.paymentMethod != null &&
          Object.hasOwnProperty.call(message, "paymentMethod")
        )
          writer
            .uint32(/* id 4, wireType 2 =*/ 34)
            .string(message.paymentMethod);
        if (message.values != null && message.values.length)
          for (let i = 0; i < message.values.length; ++i)
            $root.vhmformapi.onlineCancel.CancellationFormInput.SetupForm.encode(
              message.values[i],
              writer.uint32(/* id 5, wireType 2 =*/ 42).fork()
            ).ldelim();
        if (
          message.formType != null &&
          Object.hasOwnProperty.call(message, "formType")
        )
          writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.formType);
        if (
          message.bukkakuCode != null &&
          Object.hasOwnProperty.call(message, "bukkakuCode")
        )
          writer.uint32(/* id 7, wireType 2 =*/ 58).string(message.bukkakuCode);
        if (
          message.parkingName01 != null &&
          Object.hasOwnProperty.call(message, "parkingName01")
        )
          writer
            .uint32(/* id 8, wireType 2 =*/ 66)
            .string(message.parkingName01);
        if (
          message.parkingName02 != null &&
          Object.hasOwnProperty.call(message, "parkingName02")
        )
          writer
            .uint32(/* id 9, wireType 2 =*/ 74)
            .string(message.parkingName02);
        if (
          message.parkingName03 != null &&
          Object.hasOwnProperty.call(message, "parkingName03")
        )
          writer
            .uint32(/* id 10, wireType 2 =*/ 82)
            .string(message.parkingName03);
        if (
          message.contractId != null &&
          Object.hasOwnProperty.call(message, "contractId")
        )
          writer.uint32(/* id 11, wireType 2 =*/ 90).string(message.contractId);
        if (
          message.parkingContractId01 != null &&
          Object.hasOwnProperty.call(message, "parkingContractId01")
        )
          writer
            .uint32(/* id 12, wireType 2 =*/ 98)
            .string(message.parkingContractId01);
        if (
          message.parkingContractId02 != null &&
          Object.hasOwnProperty.call(message, "parkingContractId02")
        )
          writer
            .uint32(/* id 13, wireType 2 =*/ 106)
            .string(message.parkingContractId02);
        if (
          message.parkingContractId03 != null &&
          Object.hasOwnProperty.call(message, "parkingContractId03")
        )
          writer
            .uint32(/* id 14, wireType 2 =*/ 114)
            .string(message.parkingContractId03);
        if (
          message.sendDate != null &&
          Object.hasOwnProperty.call(message, "sendDate")
        )
          writer.uint32(/* id 15, wireType 2 =*/ 122).string(message.sendDate);
        return writer;
      };

      /**
       * Decodes a CancellationFormInput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.onlineCancel.CancellationFormInput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.onlineCancel.CancellationFormInput} CancellationFormInput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      CancellationFormInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.vhmformapi.onlineCancel.CancellationFormInput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.accountId = reader.string();
              break;
            }
            case 2: {
              message.language = reader.string();
              break;
            }
            case 3: {
              message.noticePeriod = reader.string();
              break;
            }
            case 4: {
              message.paymentMethod = reader.string();
              break;
            }
            case 5: {
              if (!(message.values && message.values.length))
                message.values = [];
              message.values.push(
                $root.vhmformapi.onlineCancel.CancellationFormInput.SetupForm.decode(
                  reader,
                  reader.uint32()
                )
              );
              break;
            }
            case 6: {
              message.formType = reader.string();
              break;
            }
            case 7: {
              message.bukkakuCode = reader.string();
              break;
            }
            case 8: {
              message.parkingName01 = reader.string();
              break;
            }
            case 9: {
              message.parkingName02 = reader.string();
              break;
            }
            case 10: {
              message.parkingName03 = reader.string();
              break;
            }
            case 11: {
              message.contractId = reader.string();
              break;
            }
            case 12: {
              message.parkingContractId01 = reader.string();
              break;
            }
            case 13: {
              message.parkingContractId02 = reader.string();
              break;
            }
            case 14: {
              message.parkingContractId03 = reader.string();
              break;
            }
            case 15: {
              message.sendDate = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      CancellationFormInput.SetupForm = (function () {
        /**
         * Properties of a SetupForm.
         * @memberof vhmformapi.onlineCancel.CancellationFormInput
         * @interface ISetupForm
         * @property {string|null} [name] SetupForm name
         * @property {Object.<string,string>|null} [value] SetupForm value
         */

        /**
         * Constructs a new SetupForm.
         * @memberof vhmformapi.onlineCancel.CancellationFormInput
         * @classdesc Represents a SetupForm.
         * @implements ISetupForm
         * @constructor
         * @param {vhmformapi.onlineCancel.CancellationFormInput.ISetupForm=} [properties] Properties to set
         */
        function SetupForm(properties) {
          this.value = {};
          if (properties)
            for (
              let keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * SetupForm name.
         * @member {string} name
         * @memberof vhmformapi.onlineCancel.CancellationFormInput.SetupForm
         * @instance
         */
        SetupForm.prototype.name = "";

        /**
         * SetupForm value.
         * @member {Object.<string,string>} value
         * @memberof vhmformapi.onlineCancel.CancellationFormInput.SetupForm
         * @instance
         */
        SetupForm.prototype.value = $util.emptyObject;

        /**
         * Creates a new SetupForm instance using the specified properties.
         * @function create
         * @memberof vhmformapi.onlineCancel.CancellationFormInput.SetupForm
         * @static
         * @param {vhmformapi.onlineCancel.CancellationFormInput.ISetupForm=} [properties] Properties to set
         * @returns {vhmformapi.onlineCancel.CancellationFormInput.SetupForm} SetupForm instance
         */
        SetupForm.create = function create(properties) {
          return new SetupForm(properties);
        };

        /**
         * Encodes the specified SetupForm message. Does not implicitly {@link vhmformapi.onlineCancel.CancellationFormInput.SetupForm.verify|verify} messages.
         * @function encode
         * @memberof vhmformapi.onlineCancel.CancellationFormInput.SetupForm
         * @static
         * @param {vhmformapi.onlineCancel.CancellationFormInput.ISetupForm} message SetupForm message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetupForm.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.name != null &&
            Object.hasOwnProperty.call(message, "name")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (
            message.value != null &&
            Object.hasOwnProperty.call(message, "value")
          )
            for (
              let keys = Object.keys(message.value), i = 0;
              i < keys.length;
              ++i
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .fork()
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(keys[i])
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.value[keys[i]])
                .ldelim();
          return writer;
        };

        /**
         * Decodes a SetupForm message from the specified reader or buffer.
         * @function decode
         * @memberof vhmformapi.onlineCancel.CancellationFormInput.SetupForm
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {vhmformapi.onlineCancel.CancellationFormInput.SetupForm} SetupForm
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetupForm.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length,
            message =
              new $root.vhmformapi.onlineCancel.CancellationFormInput.SetupForm(),
            key,
            value;
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1: {
                message.name = reader.string();
                break;
              }
              case 2: {
                if (message.value === $util.emptyObject) message.value = {};
                let end2 = reader.uint32() + reader.pos;
                key = "";
                value = "";
                while (reader.pos < end2) {
                  let tag2 = reader.uint32();
                  switch (tag2 >>> 3) {
                    case 1:
                      key = reader.string();
                      break;
                    case 2:
                      value = reader.string();
                      break;
                    default:
                      reader.skipType(tag2 & 7);
                      break;
                  }
                }
                message.value[key] = value;
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        return SetupForm;
      })();

      return CancellationFormInput;
    })();

    /**
     * Status enum.
     * @name vhmformapi.onlineCancel.Status
     * @enum {number}
     * @property {number} _=0 _ value
     * @property {number} Success=1 Success value
     * @property {number} Failure=2 Failure value
     */
    onlineCancel.Status = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[(valuesById[0] = "_")] = 0;
      values[(valuesById[1] = "Success")] = 1;
      values[(valuesById[2] = "Failure")] = 2;
      return values;
    })();

    onlineCancel.CancellationFormOutput = (function () {
      /**
       * Properties of a CancellationFormOutput.
       * @memberof vhmformapi.onlineCancel
       * @interface ICancellationFormOutput
       * @property {vhmformapi.onlineCancel.Status|null} [status] CancellationFormOutput status
       */

      /**
       * Constructs a new CancellationFormOutput.
       * @memberof vhmformapi.onlineCancel
       * @classdesc Represents a CancellationFormOutput.
       * @implements ICancellationFormOutput
       * @constructor
       * @param {vhmformapi.onlineCancel.ICancellationFormOutput=} [properties] Properties to set
       */
      function CancellationFormOutput(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * CancellationFormOutput status.
       * @member {vhmformapi.onlineCancel.Status} status
       * @memberof vhmformapi.onlineCancel.CancellationFormOutput
       * @instance
       */
      CancellationFormOutput.prototype.status = 0;

      /**
       * Creates a new CancellationFormOutput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.onlineCancel.CancellationFormOutput
       * @static
       * @param {vhmformapi.onlineCancel.ICancellationFormOutput=} [properties] Properties to set
       * @returns {vhmformapi.onlineCancel.CancellationFormOutput} CancellationFormOutput instance
       */
      CancellationFormOutput.create = function create(properties) {
        return new CancellationFormOutput(properties);
      };

      /**
       * Encodes the specified CancellationFormOutput message. Does not implicitly {@link vhmformapi.onlineCancel.CancellationFormOutput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.onlineCancel.CancellationFormOutput
       * @static
       * @param {vhmformapi.onlineCancel.ICancellationFormOutput} message CancellationFormOutput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      CancellationFormOutput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.status != null &&
          Object.hasOwnProperty.call(message, "status")
        )
          writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.status);
        return writer;
      };

      /**
       * Decodes a CancellationFormOutput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.onlineCancel.CancellationFormOutput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.onlineCancel.CancellationFormOutput} CancellationFormOutput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      CancellationFormOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.vhmformapi.onlineCancel.CancellationFormOutput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.status = reader.int32();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      return CancellationFormOutput;
    })();

    onlineCancel.CancellationFormService = (function () {
      /**
       * Constructs a new CancellationFormService service.
       * @memberof vhmformapi.onlineCancel
       * @classdesc Represents a CancellationFormService
       * @extends $protobuf.rpc.Service
       * @constructor
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       */
      function CancellationFormService(
        rpcImpl,
        requestDelimited,
        responseDelimited
      ) {
        $protobuf.rpc.Service.call(
          this,
          rpcImpl,
          requestDelimited,
          responseDelimited
        );
      }

      (CancellationFormService.prototype = Object.create(
        $protobuf.rpc.Service.prototype
      )).constructor = CancellationFormService;

      /**
       * Creates new CancellationFormService service using the specified rpc implementation.
       * @function create
       * @memberof vhmformapi.onlineCancel.CancellationFormService
       * @static
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       * @returns {CancellationFormService} RPC service. Useful where requests and/or responses are streamed.
       */
      CancellationFormService.create = function create(
        rpcImpl,
        requestDelimited,
        responseDelimited
      ) {
        return new this(rpcImpl, requestDelimited, responseDelimited);
      };

      /**
       * Callback as used by {@link vhmformapi.onlineCancel.CancellationFormService#submit}.
       * @memberof vhmformapi.onlineCancel.CancellationFormService
       * @typedef SubmitCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {vhmformapi.onlineCancel.CancellationFormOutput} [response] CancellationFormOutput
       */

      /**
       * Calls Submit.
       * @function submit
       * @memberof vhmformapi.onlineCancel.CancellationFormService
       * @instance
       * @param {vhmformapi.onlineCancel.ICancellationFormInput} request CancellationFormInput message or plain object
       * @param {vhmformapi.onlineCancel.CancellationFormService.SubmitCallback} callback Node-style callback called with the error, if any, and CancellationFormOutput
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (CancellationFormService.prototype.submit = function submit(
          request,
          callback
        ) {
          return this.rpcCall(
            submit,
            $root.vhmformapi.onlineCancel.CancellationFormInput,
            $root.vhmformapi.onlineCancel.CancellationFormOutput,
            request,
            callback
          );
        }),
        "name",
        { value: "Submit" }
      );

      /**
       * Calls Submit.
       * @function submit
       * @memberof vhmformapi.onlineCancel.CancellationFormService
       * @instance
       * @param {vhmformapi.onlineCancel.ICancellationFormInput} request CancellationFormInput message or plain object
       * @returns {Promise<vhmformapi.onlineCancel.CancellationFormOutput>} Promise
       * @variation 2
       */

      return CancellationFormService;
    })();

    return onlineCancel;
  })();

  vhmformapi.roommateInfo = (function () {
    /**
     * Namespace roommateInfo.
     * @memberof vhmformapi
     * @namespace
     */
    const roommateInfo = {};

    /**
     * ErrorCode enum.
     * @name vhmformapi.roommateInfo.ErrorCode
     * @enum {number}
     * @property {number} ROOMMATE_INFO_INVALID_SALESFORCE_API_RESPONSE=0 ROOMMATE_INFO_INVALID_SALESFORCE_API_RESPONSE value
     * @property {number} ROOMMATE_INFO_INVALID_ID=1 ROOMMATE_INFO_INVALID_ID value
     * @property {number} ROOMMATE_INFO_INTERNAL_ERROR=2 ROOMMATE_INFO_INTERNAL_ERROR value
     * @property {number} ROOMMATE_INFO_PUT_TEXT_INTO_S3_ERROR=3 ROOMMATE_INFO_PUT_TEXT_INTO_S3_ERROR value
     * @property {number} ROOMMATE_INFO_ENCRYPT_TEXT_ERROR=4 ROOMMATE_INFO_ENCRYPT_TEXT_ERROR value
     * @property {number} ROOMMATE_INFO_CONVERT_ERROR=5 ROOMMATE_INFO_CONVERT_ERROR value
     * @property {number} ROOMMATE_INFO_FORM_FIELD_VALIDATE_ERROR=6 ROOMMATE_INFO_FORM_FIELD_VALIDATE_ERROR value
     * @property {number} ROOMMATE_INFO_GET_ACCESS_TOKEN_ERROR=7 ROOMMATE_INFO_GET_ACCESS_TOKEN_ERROR value
     * @property {number} ROOMMATE_INFO_UNDEFINED_FORM_TYPE_ERROR=8 ROOMMATE_INFO_UNDEFINED_FORM_TYPE_ERROR value
     * @property {number} ROOMMATE_INFO_INVALID_IMAGES_ERROR=9 ROOMMATE_INFO_INVALID_IMAGES_ERROR value
     */
    roommateInfo.ErrorCode = (function () {
      const valuesById = {},
        values = Object.create(valuesById);
      values[
        (valuesById[0] = "ROOMMATE_INFO_INVALID_SALESFORCE_API_RESPONSE")
      ] = 0;
      values[(valuesById[1] = "ROOMMATE_INFO_INVALID_ID")] = 1;
      values[(valuesById[2] = "ROOMMATE_INFO_INTERNAL_ERROR")] = 2;
      values[(valuesById[3] = "ROOMMATE_INFO_PUT_TEXT_INTO_S3_ERROR")] = 3;
      values[(valuesById[4] = "ROOMMATE_INFO_ENCRYPT_TEXT_ERROR")] = 4;
      values[(valuesById[5] = "ROOMMATE_INFO_CONVERT_ERROR")] = 5;
      values[(valuesById[6] = "ROOMMATE_INFO_FORM_FIELD_VALIDATE_ERROR")] = 6;
      values[(valuesById[7] = "ROOMMATE_INFO_GET_ACCESS_TOKEN_ERROR")] = 7;
      values[(valuesById[8] = "ROOMMATE_INFO_UNDEFINED_FORM_TYPE_ERROR")] = 8;
      values[(valuesById[9] = "ROOMMATE_INFO_INVALID_IMAGES_ERROR")] = 9;
      return values;
    })();

    roommateInfo.RoommateInfoFormInput = (function () {
      /**
       * Properties of a RoommateInfoFormInput.
       * @memberof vhmformapi.roommateInfo
       * @interface IRoommateInfoFormInput
       * @property {string|null} [sendMethod] RoommateInfoFormInput sendMethod
       * @property {string|null} [language] RoommateInfoFormInput language
       * @property {string|null} [bukkakuCode] RoommateInfoFormInput bukkakuCode
       * @property {string|null} [contractId] RoommateInfoFormInput contractId
       * @property {string|null} [expires] RoommateInfoFormInput expires
       * @property {string|null} [mailFlag] RoommateInfoFormInput mailFlag
       * @property {Array.<vhmformapi.roommateInfo.RoommateInfoFormInput.ISetupForm>|null} [values] RoommateInfoFormInput values
       * @property {Array.<vhmformapi.roommateInfo.RoommateInfoFormInput.IImage>|null} [images] RoommateInfoFormInput images
       * @property {string|null} [uniqId] RoommateInfoFormInput uniqId
       */

      /**
       * Constructs a new RoommateInfoFormInput.
       * @memberof vhmformapi.roommateInfo
       * @classdesc Represents a RoommateInfoFormInput.
       * @implements IRoommateInfoFormInput
       * @constructor
       * @param {vhmformapi.roommateInfo.IRoommateInfoFormInput=} [properties] Properties to set
       */
      function RoommateInfoFormInput(properties) {
        this.values = [];
        this.images = [];
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * RoommateInfoFormInput sendMethod.
       * @member {string} sendMethod
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput
       * @instance
       */
      RoommateInfoFormInput.prototype.sendMethod = "";

      /**
       * RoommateInfoFormInput language.
       * @member {string} language
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput
       * @instance
       */
      RoommateInfoFormInput.prototype.language = "";

      /**
       * RoommateInfoFormInput bukkakuCode.
       * @member {string} bukkakuCode
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput
       * @instance
       */
      RoommateInfoFormInput.prototype.bukkakuCode = "";

      /**
       * RoommateInfoFormInput contractId.
       * @member {string} contractId
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput
       * @instance
       */
      RoommateInfoFormInput.prototype.contractId = "";

      /**
       * RoommateInfoFormInput expires.
       * @member {string} expires
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput
       * @instance
       */
      RoommateInfoFormInput.prototype.expires = "";

      /**
       * RoommateInfoFormInput mailFlag.
       * @member {string} mailFlag
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput
       * @instance
       */
      RoommateInfoFormInput.prototype.mailFlag = "";

      /**
       * RoommateInfoFormInput values.
       * @member {Array.<vhmformapi.roommateInfo.RoommateInfoFormInput.ISetupForm>} values
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput
       * @instance
       */
      RoommateInfoFormInput.prototype.values = $util.emptyArray;

      /**
       * RoommateInfoFormInput images.
       * @member {Array.<vhmformapi.roommateInfo.RoommateInfoFormInput.IImage>} images
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput
       * @instance
       */
      RoommateInfoFormInput.prototype.images = $util.emptyArray;

      /**
       * RoommateInfoFormInput uniqId.
       * @member {string} uniqId
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput
       * @instance
       */
      RoommateInfoFormInput.prototype.uniqId = "";

      /**
       * Creates a new RoommateInfoFormInput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput
       * @static
       * @param {vhmformapi.roommateInfo.IRoommateInfoFormInput=} [properties] Properties to set
       * @returns {vhmformapi.roommateInfo.RoommateInfoFormInput} RoommateInfoFormInput instance
       */
      RoommateInfoFormInput.create = function create(properties) {
        return new RoommateInfoFormInput(properties);
      };

      /**
       * Encodes the specified RoommateInfoFormInput message. Does not implicitly {@link vhmformapi.roommateInfo.RoommateInfoFormInput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput
       * @static
       * @param {vhmformapi.roommateInfo.IRoommateInfoFormInput} message RoommateInfoFormInput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      RoommateInfoFormInput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.sendMethod != null &&
          Object.hasOwnProperty.call(message, "sendMethod")
        )
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.sendMethod);
        if (
          message.language != null &&
          Object.hasOwnProperty.call(message, "language")
        )
          writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.language);
        if (
          message.bukkakuCode != null &&
          Object.hasOwnProperty.call(message, "bukkakuCode")
        )
          writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.bukkakuCode);
        if (
          message.contractId != null &&
          Object.hasOwnProperty.call(message, "contractId")
        )
          writer.uint32(/* id 4, wireType 2 =*/ 34).string(message.contractId);
        if (
          message.expires != null &&
          Object.hasOwnProperty.call(message, "expires")
        )
          writer.uint32(/* id 5, wireType 2 =*/ 42).string(message.expires);
        if (
          message.mailFlag != null &&
          Object.hasOwnProperty.call(message, "mailFlag")
        )
          writer.uint32(/* id 6, wireType 2 =*/ 50).string(message.mailFlag);
        if (message.values != null && message.values.length)
          for (let i = 0; i < message.values.length; ++i)
            $root.vhmformapi.roommateInfo.RoommateInfoFormInput.SetupForm.encode(
              message.values[i],
              writer.uint32(/* id 7, wireType 2 =*/ 58).fork()
            ).ldelim();
        if (message.images != null && message.images.length)
          for (let i = 0; i < message.images.length; ++i)
            $root.vhmformapi.roommateInfo.RoommateInfoFormInput.Image.encode(
              message.images[i],
              writer.uint32(/* id 8, wireType 2 =*/ 66).fork()
            ).ldelim();
        if (
          message.uniqId != null &&
          Object.hasOwnProperty.call(message, "uniqId")
        )
          writer.uint32(/* id 9, wireType 2 =*/ 74).string(message.uniqId);
        return writer;
      };

      /**
       * Decodes a RoommateInfoFormInput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.roommateInfo.RoommateInfoFormInput} RoommateInfoFormInput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      RoommateInfoFormInput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.vhmformapi.roommateInfo.RoommateInfoFormInput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.sendMethod = reader.string();
              break;
            }
            case 2: {
              message.language = reader.string();
              break;
            }
            case 3: {
              message.bukkakuCode = reader.string();
              break;
            }
            case 4: {
              message.contractId = reader.string();
              break;
            }
            case 5: {
              message.expires = reader.string();
              break;
            }
            case 6: {
              message.mailFlag = reader.string();
              break;
            }
            case 7: {
              if (!(message.values && message.values.length))
                message.values = [];
              message.values.push(
                $root.vhmformapi.roommateInfo.RoommateInfoFormInput.SetupForm.decode(
                  reader,
                  reader.uint32()
                )
              );
              break;
            }
            case 8: {
              if (!(message.images && message.images.length))
                message.images = [];
              message.images.push(
                $root.vhmformapi.roommateInfo.RoommateInfoFormInput.Image.decode(
                  reader,
                  reader.uint32()
                )
              );
              break;
            }
            case 9: {
              message.uniqId = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      RoommateInfoFormInput.Image = (function () {
        /**
         * Properties of an Image.
         * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput
         * @interface IImage
         * @property {string|null} [name] Image name
         * @property {string|null} [type] Image type
         * @property {string|null} [position] Image position
         */

        /**
         * Constructs a new Image.
         * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput
         * @classdesc Represents an Image.
         * @implements IImage
         * @constructor
         * @param {vhmformapi.roommateInfo.RoommateInfoFormInput.IImage=} [properties] Properties to set
         */
        function Image(properties) {
          if (properties)
            for (
              let keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * Image name.
         * @member {string} name
         * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput.Image
         * @instance
         */
        Image.prototype.name = "";

        /**
         * Image type.
         * @member {string} type
         * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput.Image
         * @instance
         */
        Image.prototype.type = "";

        /**
         * Image position.
         * @member {string} position
         * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput.Image
         * @instance
         */
        Image.prototype.position = "";

        /**
         * Creates a new Image instance using the specified properties.
         * @function create
         * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput.Image
         * @static
         * @param {vhmformapi.roommateInfo.RoommateInfoFormInput.IImage=} [properties] Properties to set
         * @returns {vhmformapi.roommateInfo.RoommateInfoFormInput.Image} Image instance
         */
        Image.create = function create(properties) {
          return new Image(properties);
        };

        /**
         * Encodes the specified Image message. Does not implicitly {@link vhmformapi.roommateInfo.RoommateInfoFormInput.Image.verify|verify} messages.
         * @function encode
         * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput.Image
         * @static
         * @param {vhmformapi.roommateInfo.RoommateInfoFormInput.IImage} message Image message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Image.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.name != null &&
            Object.hasOwnProperty.call(message, "name")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (
            message.type != null &&
            Object.hasOwnProperty.call(message, "type")
          )
            writer.uint32(/* id 2, wireType 2 =*/ 18).string(message.type);
          if (
            message.position != null &&
            Object.hasOwnProperty.call(message, "position")
          )
            writer.uint32(/* id 3, wireType 2 =*/ 26).string(message.position);
          return writer;
        };

        /**
         * Decodes an Image message from the specified reader or buffer.
         * @function decode
         * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput.Image
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {vhmformapi.roommateInfo.RoommateInfoFormInput.Image} Image
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Image.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length,
            message =
              new $root.vhmformapi.roommateInfo.RoommateInfoFormInput.Image();
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1: {
                message.name = reader.string();
                break;
              }
              case 2: {
                message.type = reader.string();
                break;
              }
              case 3: {
                message.position = reader.string();
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        return Image;
      })();

      RoommateInfoFormInput.SetupForm = (function () {
        /**
         * Properties of a SetupForm.
         * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput
         * @interface ISetupForm
         * @property {string|null} [name] SetupForm name
         * @property {Object.<string,string>|null} [value] SetupForm value
         */

        /**
         * Constructs a new SetupForm.
         * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput
         * @classdesc Represents a SetupForm.
         * @implements ISetupForm
         * @constructor
         * @param {vhmformapi.roommateInfo.RoommateInfoFormInput.ISetupForm=} [properties] Properties to set
         */
        function SetupForm(properties) {
          this.value = {};
          if (properties)
            for (
              let keys = Object.keys(properties), i = 0;
              i < keys.length;
              ++i
            )
              if (properties[keys[i]] != null)
                this[keys[i]] = properties[keys[i]];
        }

        /**
         * SetupForm name.
         * @member {string} name
         * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput.SetupForm
         * @instance
         */
        SetupForm.prototype.name = "";

        /**
         * SetupForm value.
         * @member {Object.<string,string>} value
         * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput.SetupForm
         * @instance
         */
        SetupForm.prototype.value = $util.emptyObject;

        /**
         * Creates a new SetupForm instance using the specified properties.
         * @function create
         * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput.SetupForm
         * @static
         * @param {vhmformapi.roommateInfo.RoommateInfoFormInput.ISetupForm=} [properties] Properties to set
         * @returns {vhmformapi.roommateInfo.RoommateInfoFormInput.SetupForm} SetupForm instance
         */
        SetupForm.create = function create(properties) {
          return new SetupForm(properties);
        };

        /**
         * Encodes the specified SetupForm message. Does not implicitly {@link vhmformapi.roommateInfo.RoommateInfoFormInput.SetupForm.verify|verify} messages.
         * @function encode
         * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput.SetupForm
         * @static
         * @param {vhmformapi.roommateInfo.RoommateInfoFormInput.ISetupForm} message SetupForm message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SetupForm.encode = function encode(message, writer) {
          if (!writer) writer = $Writer.create();
          if (
            message.name != null &&
            Object.hasOwnProperty.call(message, "name")
          )
            writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.name);
          if (
            message.value != null &&
            Object.hasOwnProperty.call(message, "value")
          )
            for (
              let keys = Object.keys(message.value), i = 0;
              i < keys.length;
              ++i
            )
              writer
                .uint32(/* id 2, wireType 2 =*/ 18)
                .fork()
                .uint32(/* id 1, wireType 2 =*/ 10)
                .string(keys[i])
                .uint32(/* id 2, wireType 2 =*/ 18)
                .string(message.value[keys[i]])
                .ldelim();
          return writer;
        };

        /**
         * Decodes a SetupForm message from the specified reader or buffer.
         * @function decode
         * @memberof vhmformapi.roommateInfo.RoommateInfoFormInput.SetupForm
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {vhmformapi.roommateInfo.RoommateInfoFormInput.SetupForm} SetupForm
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SetupForm.decode = function decode(reader, length) {
          if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
          let end = length === undefined ? reader.len : reader.pos + length,
            message =
              new $root.vhmformapi.roommateInfo.RoommateInfoFormInput.SetupForm(),
            key,
            value;
          while (reader.pos < end) {
            let tag = reader.uint32();
            switch (tag >>> 3) {
              case 1: {
                message.name = reader.string();
                break;
              }
              case 2: {
                if (message.value === $util.emptyObject) message.value = {};
                let end2 = reader.uint32() + reader.pos;
                key = "";
                value = "";
                while (reader.pos < end2) {
                  let tag2 = reader.uint32();
                  switch (tag2 >>> 3) {
                    case 1:
                      key = reader.string();
                      break;
                    case 2:
                      value = reader.string();
                      break;
                    default:
                      reader.skipType(tag2 & 7);
                      break;
                  }
                }
                message.value[key] = value;
                break;
              }
              default:
                reader.skipType(tag & 7);
                break;
            }
          }
          return message;
        };

        return SetupForm;
      })();

      return RoommateInfoFormInput;
    })();

    roommateInfo.RoommateInfoFormOutput = (function () {
      /**
       * Properties of a RoommateInfoFormOutput.
       * @memberof vhmformapi.roommateInfo
       * @interface IRoommateInfoFormOutput
       * @property {string|null} [uniqId] RoommateInfoFormOutput uniqId
       */

      /**
       * Constructs a new RoommateInfoFormOutput.
       * @memberof vhmformapi.roommateInfo
       * @classdesc Represents a RoommateInfoFormOutput.
       * @implements IRoommateInfoFormOutput
       * @constructor
       * @param {vhmformapi.roommateInfo.IRoommateInfoFormOutput=} [properties] Properties to set
       */
      function RoommateInfoFormOutput(properties) {
        if (properties)
          for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
            if (properties[keys[i]] != null)
              this[keys[i]] = properties[keys[i]];
      }

      /**
       * RoommateInfoFormOutput uniqId.
       * @member {string} uniqId
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormOutput
       * @instance
       */
      RoommateInfoFormOutput.prototype.uniqId = "";

      /**
       * Creates a new RoommateInfoFormOutput instance using the specified properties.
       * @function create
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormOutput
       * @static
       * @param {vhmformapi.roommateInfo.IRoommateInfoFormOutput=} [properties] Properties to set
       * @returns {vhmformapi.roommateInfo.RoommateInfoFormOutput} RoommateInfoFormOutput instance
       */
      RoommateInfoFormOutput.create = function create(properties) {
        return new RoommateInfoFormOutput(properties);
      };

      /**
       * Encodes the specified RoommateInfoFormOutput message. Does not implicitly {@link vhmformapi.roommateInfo.RoommateInfoFormOutput.verify|verify} messages.
       * @function encode
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormOutput
       * @static
       * @param {vhmformapi.roommateInfo.IRoommateInfoFormOutput} message RoommateInfoFormOutput message or plain object to encode
       * @param {$protobuf.Writer} [writer] Writer to encode to
       * @returns {$protobuf.Writer} Writer
       */
      RoommateInfoFormOutput.encode = function encode(message, writer) {
        if (!writer) writer = $Writer.create();
        if (
          message.uniqId != null &&
          Object.hasOwnProperty.call(message, "uniqId")
        )
          writer.uint32(/* id 1, wireType 2 =*/ 10).string(message.uniqId);
        return writer;
      };

      /**
       * Decodes a RoommateInfoFormOutput message from the specified reader or buffer.
       * @function decode
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormOutput
       * @static
       * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
       * @param {number} [length] Message length if known beforehand
       * @returns {vhmformapi.roommateInfo.RoommateInfoFormOutput} RoommateInfoFormOutput
       * @throws {Error} If the payload is not a reader or valid buffer
       * @throws {$protobuf.util.ProtocolError} If required fields are missing
       */
      RoommateInfoFormOutput.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
        let end = length === undefined ? reader.len : reader.pos + length,
          message = new $root.vhmformapi.roommateInfo.RoommateInfoFormOutput();
        while (reader.pos < end) {
          let tag = reader.uint32();
          switch (tag >>> 3) {
            case 1: {
              message.uniqId = reader.string();
              break;
            }
            default:
              reader.skipType(tag & 7);
              break;
          }
        }
        return message;
      };

      return RoommateInfoFormOutput;
    })();

    roommateInfo.RoommateInfoFormService = (function () {
      /**
       * Constructs a new RoommateInfoFormService service.
       * @memberof vhmformapi.roommateInfo
       * @classdesc Represents a RoommateInfoFormService
       * @extends $protobuf.rpc.Service
       * @constructor
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       */
      function RoommateInfoFormService(
        rpcImpl,
        requestDelimited,
        responseDelimited
      ) {
        $protobuf.rpc.Service.call(
          this,
          rpcImpl,
          requestDelimited,
          responseDelimited
        );
      }

      (RoommateInfoFormService.prototype = Object.create(
        $protobuf.rpc.Service.prototype
      )).constructor = RoommateInfoFormService;

      /**
       * Creates new RoommateInfoFormService service using the specified rpc implementation.
       * @function create
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormService
       * @static
       * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
       * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
       * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
       * @returns {RoommateInfoFormService} RPC service. Useful where requests and/or responses are streamed.
       */
      RoommateInfoFormService.create = function create(
        rpcImpl,
        requestDelimited,
        responseDelimited
      ) {
        return new this(rpcImpl, requestDelimited, responseDelimited);
      };

      /**
       * Callback as used by {@link vhmformapi.roommateInfo.RoommateInfoFormService#submit}.
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormService
       * @typedef SubmitCallback
       * @type {function}
       * @param {Error|null} error Error, if any
       * @param {vhmformapi.roommateInfo.RoommateInfoFormOutput} [response] RoommateInfoFormOutput
       */

      /**
       * Calls Submit.
       * @function submit
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormService
       * @instance
       * @param {vhmformapi.roommateInfo.IRoommateInfoFormInput} request RoommateInfoFormInput message or plain object
       * @param {vhmformapi.roommateInfo.RoommateInfoFormService.SubmitCallback} callback Node-style callback called with the error, if any, and RoommateInfoFormOutput
       * @returns {undefined}
       * @variation 1
       */
      Object.defineProperty(
        (RoommateInfoFormService.prototype.submit = function submit(
          request,
          callback
        ) {
          return this.rpcCall(
            submit,
            $root.vhmformapi.roommateInfo.RoommateInfoFormInput,
            $root.vhmformapi.roommateInfo.RoommateInfoFormOutput,
            request,
            callback
          );
        }),
        "name",
        { value: "Submit" }
      );

      /**
       * Calls Submit.
       * @function submit
       * @memberof vhmformapi.roommateInfo.RoommateInfoFormService
       * @instance
       * @param {vhmformapi.roommateInfo.IRoommateInfoFormInput} request RoommateInfoFormInput message or plain object
       * @returns {Promise<vhmformapi.roommateInfo.RoommateInfoFormOutput>} Promise
       * @variation 2
       */

      return RoommateInfoFormService;
    })();

    return roommateInfo;
  })();

  return vhmformapi;
})());

export { $root as default };
